import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import es from './es';

const STORAGE_KEY = 'fb_lang';
const DEFAULT_LANG = 'pt';
// Every supported language; order is the order of the language switcher.
export const LANGS = ['en', 'pt', 'es'];
export const nextLang = (lang) => LANGS[(LANGS.indexOf(lang) + 1) % LANGS.length];
// Locale for dates and numbers.
export const LOCALE = { en: 'en-GB', pt: 'pt-PT', es: 'es-ES' };

const dict = {
  pt: {
    // Boas-vindas (1º acesso)
    'wel.eyebrow': 'Bem-vindo ao My Football Game',
    'wel.title': 'A tua equipa está pronta!',
    'wel.squadReady': 'Criámos-te uma equipa inicial com plantel completo — já está no teu Plantel, pronta a jogar.',
    'wel.squad': 'Plantel: gere o teu onze, suplentes e reservas.',
    'wel.tactics': 'Táticas: escolhe a formação e o estilo de jogo.',
    'wel.challenge': 'Desafios: joga contra outras equipas e sobe na liga.',
    'wel.shop': 'Loja: abre packs de jogadores com gold.',
    'wel.seeSquad': 'Ver o meu plantel',
    'wel.explore': 'Explorar primeiro',
    // Nav & Geral
    'nav.dashboard': 'Início',
    'nav.squad': 'Plantel',
    'sq.swapped': '{in} para o XI; {out} para suplentes.',
    'sq.xiFull': 'O onze já tem 11 — promove e trocamos automaticamente, ou tira um titular.',
    'sq.injuredBlock': 'Jogador lesionado — só pode ficar nas reservas.',
    'sq.injuredBlockN': 'Jogador lesionado ({n} jogos) — só pode ficar nas reservas.',
    'sq.sell': 'Vender',
    'sq.modifyListing': 'Alterar preço',
    'sq.quickSell': 'Venda rápida',
    'sq.quickSellHint': 'Vende já por 60% do valor de mercado.',
    'sq.sellHint': 'Tira do onze/banco para poder vender.',
    'sq.soldFor': '{name} vendido por €{coins}.',
    'sq.sold': 'Jogador vendido.',
    'sq.sellErr': 'Não foi possível vender.',

    'nav.training': 'Treinos',
    'nav.tactics': 'Táticas',
    'nav.transfers': 'Transferências',
    'nav.league': 'Liga',
    'nav.leaderboard': 'Rankings',
    'nav.challenges': 'Desafios',
    'nav.friends': 'Amigos',
    'nav.matches': 'Jogos',
    'nav.shop': 'Loja',
    'nav.settings': 'Definições',
    'nav.menu': 'Menu',
    // Definições
    'set.section': 'Conta · Definições',
    'set.title': 'DEFINIÇÕES',
    'set.subtitle': 'Gere a tua conta, dados do clube e preferências.',
    'set.profile': 'Perfil',
    'set.email': 'Email',
    'set.coachName': 'Nome do treinador',
    'set.clubName': 'Nome do clube',
    'set.save': 'Guardar',
    'set.saved': 'Guardado!',
    'set.coachNameNote': 'Para mudar o nome do treinador é preciso um endpoint no backend.',
    'set.preferences': 'Preferências',
    'tour.dashboard': 'Início — o teu gabinete: orçamento, ranking e próximo jogo.',
    'tour.squad': 'Plantel — gere o teu onze, suplentes e reservas; vende jogadores.',
    'tour.tactics': 'Táticas — escolhe a formação e o estilo de jogo.',
    'tour.league': 'Liga — joga desafios e sobe na classificação.',
    'tour.menu': 'Menu — loja, ligas privadas, amigos e definições.',
    'tour.next': 'Seguinte',
    'tour.done': 'Começar!',
    'notif.promptTitle': 'Ativar notificações?',
    'notif.promptBody': 'Recebe alertas quando fores desafiado, com o resultado do jogo e em vendas de jogadores.',
    'notif.promptYes': 'Ativar notificações',
    'notif.promptNo': 'Agora não',
    'set.coachName': 'Nome do treinador',
    'set.renameToken': 'Renomear',
    'set.coachTokenNote': 'Requer um “Coach Rename Token” (compra na Loja, 100 gold).',
    'set.coachRenamed': 'Treinador renomeado!',
    'set.needCoachToken': 'Precisas de um Coach Rename Token. Compra-o na Loja.',
    'set.notifications': 'Notificações',
    'set.notifPush': 'Notificações no dispositivo',
    'set.notifOn': 'Ativadas — recebes alertas de desafios, resultados e vendas.',
    'set.notifOff': 'Desativadas. Ativa para receberes alertas.',
    'set.notifBlocked': 'Bloqueadas no browser. Ativa nas definições do site.',
    'set.notifActive': 'Ativas',
    'set.notifEnable': 'Ativar',
    'set.notifRecent': 'Recentes',
    'set.notifMarkAll': 'Marcar tudo lido',
    'set.notifEmpty': 'Sem notificações.',
    'set.language': 'Idioma',
    'set.account': 'Conta',
    'set.logout': 'Terminar sessão',
    'set.logoutHint': 'Sais da tua conta neste dispositivo.',
    'set.changePassword': 'Alterar password',
    'set.changePasswordHint': 'Enviamos um link de redefinição para o teu email.',
    'set.passwordEmailSent': 'Email de redefinição enviado!',
    'set.deleteAccount': 'Eliminar conta',
    'set.deleteHint': 'Apaga permanentemente a conta e todos os dados. Irreversível.',
    'set.deleteConfirmTitle': 'Eliminar conta?',
    'set.deleteConfirmBody': 'Esta ação é permanente e apaga a tua equipa, jogadores e histórico. Confirma com a tua password.',
    'set.passwordPlaceholder': 'A tua password',
    'set.deleteBtn': 'Eliminar definitivamente',
    'set.cancel': 'Cancelar',
    'set.errGeneric': 'Algo correu mal. Tenta de novo.',
    'set.emailInUse': 'Esse email já está em uso.',
    'nav.home': 'Início',
    'nav.section': 'Navegação',
    'share.result': 'Partilhar resultado',
    'share.won': 'Ganhei {score} ao {opp} ⚽ Achas que fazes melhor?',
    'share.drew': 'Empatei {score} com o {opp} ⚽ Achas que fazes melhor?',
    'share.lost': 'Perdi {score} com o {opp}... Achas que fazes melhor? ⚽',
    'share.winPrompt': 'Ganhaste {score}! Desafia um amigo a fazer melhor contra o teu clube.',
    'share.challenge': 'Desafiar amigo',
    'share.share': 'Partilhar',
    'share.via': 'Partilhar via',
    'share.copyLink': 'Copiar link',
    'share.copied': 'Copiado!',
    'cl.email': 'Email',
    'cl.password': 'Palavra-passe (mín. 6)',
    'cl.coachName': 'Nome de treinador (opcional)',
    'cl.save': 'Guardar o meu clube',
    'cl.saveGoogle': 'Guardar com Google',
    'cl.orEmail': 'ou com email',
    'cl.claimError': 'Não foi possível guardar o clube.',
    'cl.notFound': 'Este desafio não existe ou expirou.',
    'cl.playError': 'Não foi possível começar o jogo.',
    'cl.discover': 'Conhecer o jogo',
    'cl.challengedBy': '{coach} desafia-te!',
    'cl.record': '{w}V {d}E {l}D',
    'cl.plays': '{n} desafios aceites',
    'cl.pitch': 'Monta a tua equipa num segundo e joga já contra este clube.',
    'cl.yourTeam': 'Nome da tua equipa (opcional)',
    'cl.playNow': 'Aceitar o desafio',
    'cl.playWithMyClub': 'Jogar com o meu clube',
    'cl.noSignup': 'Grátis, sem registo, joga no browser.',
    'cl.keepTitle': 'Guarda o teu clube',
    'cl.keepBody': 'Mantém a tua equipa, fica amigo de {coach} e joga a tua época.',
    'cl.keepBodyGame': 'Estás a jogar como convidado. Guarda o clube para não perderes a equipa nem os resultados.',
    'cl.continueGuest': 'Continuar como convidado',
    'cl.goToGame': 'Ir para o jogo',
    'cl.rematch': 'Revanche',
    'cl.guestBanner': 'Estás a jogar como convidado. Guarda o teu clube para não o perderes.',
    'inv.title': 'Desafia amigos com um link',
    'inv.body': 'Enviam o link, jogam contra o teu clube no momento, sem registo.',
    'inv.share': 'Partilhar',
    'inv.copy': 'Copiar',
    'inv.copied': 'Copiado!',
    'inv.error': 'Não foi possível criar o link.',
    'inv.message': 'Aposto que não ganhas ao {team} ⚽ Joga já, sem registo:',
    'inv.passOnTitle': 'Agora é a tua vez de desafiar',
    'inv.passOnBody': 'Já tens o teu próprio clube. Envia o link a um amigo e vê se ele te ganha.',
    'h2h.title': 'Frente a frente',
    'h2h.wdl': 'V-E-D',
    'h2h.played': '{n} jogos',
    'h2h.goals': 'Golos {gf}-{ga}',
    'h2h.recent': 'Últimos jogos',
    'h2h.never': 'Ainda não jogaste contra {name}. Está na hora!',
    'h2h.revenge': 'Vingança!',
    'h2h.challenge': 'Desafiar {name}',
    'h2h.short': 'Vs ti:',
    'h2h.noneYet': 'Ainda sem jogos entre vocês',
    'h2h.loadError': 'Não foi possível carregar o frente a frente.',
    'h2h.r.W': 'V',
    'h2h.r.D': 'E',
    'h2h.r.L': 'D',
    'rk.title': 'Liga Ranked',
    'rk.subtitle': 'Desafia outros treinadores, ganha pontos e sobe de divisão.',
    'rk.you': 'TU',
    'rk.played': '{n} jogos',
    'rk.of': 'de {n}',
    'rk.toPromotion': 'Faltam {n} pts para subir a {league}',
    'rk.topLeague': 'Estás na divisão máxima. Defende o teu lugar!',
    'rk.jumpToMe': 'Ir para a minha posição',
    'rk.club': 'Clube',
    'rk.p': 'J',
    'rk.wdl': 'V-E-D',
    'rk.pts': 'Pts',
    'rk.empty': 'Ainda não há equipas nesta divisão.',
    'rk.loadError': 'Não foi possível carregar a classificação.',
    'rk.range': '{from}–{to} de {total}',
    'rk.howItWorks': 'Vitórias valem até 4 pts, empates 1, derrotas tiram 1. Atinge a meta da divisão para subir.',
    'nav.season': 'Época',
    'se.loadError': 'Não foi possível carregar a época.',
    'se.playError': 'Não foi possível iniciar o jogo.',
    'se.retry': 'Tentar de novo',
    'se.seasonN': 'Época {n}',
    'se.seasonOver': 'Época terminada',
    'se.matchdayOf': 'Jornada {n}/{total}',
    'se.openTactics': 'Abrir Táticas',
    'se.derby': 'Dérbi',
    'se.friend': 'Amigo',
    'se.obj.top_eight': 'Acabar em {pos} ou melhor',
    'se.boardReaction': 'Reação da direção',
    'se.continue': 'Continuar',
    'se.result.win': 'Vitória',
    'se.result.draw': 'Empate',
    'se.result.loss': 'Derrota',
    'se.nextVs': 'J{md} · {where} vs {opp}',
    'se.tone.thrashing': 'Que exibição! Assim é que se faz, mister.',
    'se.tone.statement_win': 'Vitória de peso contra o {opp}. Mostraste do que somos capazes.',
    'se.tone.expected_win': 'Era o resultado que esperávamos. Continua assim.',
    'se.tone.good_draw': 'Um ponto útil contra o {opp}. Aceitamos.',
    'se.tone.poor_draw': 'Um empate com o {opp}? Esperávamos mais.',
    'se.tone.tough_loss': 'Derrota frente a uma equipa forte. Compreendemos, mas não pode repetir-se.',
    'se.tone.bad_loss': 'Perder com o {opp} é inaceitável.',
    'se.tone.humiliation': 'Uma humilhação. Os adeptos merecem melhor.',
    'se.autoFilled': 'Lesões ou castigos deixaram vagas no onze. O adjunto escolheu: {names}.',
    'se.nextMatch': 'Próximo jogo',
    'se.home': 'Casa',
    'se.away': 'Fora',
    'se.watchMatch': 'Ver jogo a decorrer',
    'se.playMatchday': 'Jogar jornada {n}',
    'se.rewards': 'Vitória +{win} · Empate +{draw} moedas',
    'se.finalStanding': 'Classificação final',
    'se.outcome.champion': 'Campeão!',
    'se.outcome.promoted': 'Promovido!',
    'se.outcome.relegated': 'Despromovido',
    'se.outcome.stayed': 'Mantiveste a divisão',
    'se.nextDivision': 'Próxima época: {name}',
    'se.prizeWon': 'Prémio da época: +{coins} moedas',
    'se.prizeNone': 'Sem prémio esta época.',
    'se.startSeason': 'Começar época {n}',
    'se.board': 'Direção',
    'se.mood.delighted': 'Encantada',
    'se.mood.pleased': 'Satisfeita',
    'se.mood.neutral': 'Neutra',
    'se.mood.concerned': 'Preocupada',
    'se.mood.furious': 'Furiosa',
    'se.expectation': 'A direção espera:',
    'se.obj.title': 'Ser campeão',
    'se.obj.promotion': 'Subir de divisão (top {n})',
    'se.obj.top_three': 'Acabar no top 3',
    'se.obj.top_half': 'Metade de cima ({pos} ou melhor)',
    'se.obj.survival': 'Evitar a descida ({pos} ou melhor)',
    'se.onTrack': 'no bom caminho',
    'se.offTrack': 'abaixo do objetivo',
    'se.confidence': 'Confiança da direção',
    'se.ultimatumActive': 'ULTIMATO: vence {wins} dos próximos {matches} jogos ou perdes o prémio da época.',
    'se.prizeForfeited': 'Falhaste o ultimato — o prémio desta época foi cancelado.',
    'se.ev.season_start': 'Nova época. Contamos contigo: {target}.',
    'se.ev.warning': 'Os resultados não chegam. Esperamos uma reação já.',
    'se.ev.praise': 'Excelente trabalho, mister. A direção está encantada.',
    'se.ev.ultimatum': 'A paciência acabou. Vence {wins} dos próximos {matches} jogos.',
    'se.ev.ultimatum_passed': 'Respondeste à pressão. A direção volta a confiar em ti.',
    'se.ev.ultimatum_failed': 'Falhaste o ultimato. Não haverá prémio esta época.',
    'se.ev.verdict_met': 'Objetivo cumprido com o {pos} lugar. Parabéns!',
    'se.ev.verdict_missed': 'Acabaste em {pos}. Ficou aquém do esperado.',
    'se.promotion': 'Subida',
    'se.relegation': 'Descida',
    'se.club': 'Clube',
    'se.p': 'J',
    'se.w': 'V',
    'se.d': 'E',
    'se.l': 'D',
    'se.gd': 'DG',
    'se.pts': 'Pts',
    'se.form': 'Forma',
    'se.yourFixtures': 'Os teus jogos',
    'se.md': 'J',
    'se.lastResults': 'Última jornada',
    'se.noResults': 'Ainda não há resultados — joga a primeira jornada!',
    'nav.club': 'Clube',
    'nav.play': 'Jogar',
    'nav.compete': 'Competir',
    'nav.me': 'Perfil',
    'nav.overview': 'Resumo',
    'nav.feed': 'Comunidade',
    'nav.quickMatch': 'Jogo Rápido',
    'nav.tournaments': 'Torneios',
    'nav.career': 'Carreira',
    'nav.missions': 'Missões',
    'nav.trophies': 'Troféus',
    'tour.play': 'Jogar — o botão principal. Joga a tua época, um jogo rápido, desafia amigos ou entra em torneios.',
    'tour.club': 'Clube — plantel, táticas, treinos e transferências.',
    'tour.compete': 'Competir — liga, rankings e ligas privadas.',
    'tour.me': 'Perfil — carreira, missões, troféus, loja e definições.',
    'common.save': 'Guardar',
    'common.saving': 'A guardar...',
    'common.cancel': 'Cancelar',
    'common.close': 'Fechar',
    'common.refresh': 'Atualizar',
    'common.clear': 'Limpar',
    'common.loading': 'A carregar...',
    'common.retry': 'Tentar novamente',
    'common.all': 'Todos',
    'common.edit': 'Editar',
    'common.unknown': 'Desconhecido',

    // Header
    'header.teamRank': 'Rank Equipa',
    'header.coachRank': 'Rank Treinador',
    'header.budget': 'Orçamento',
    'header.points': 'pts',
    'header.level': 'Nível',
    'header.online': 'Online',
    'header.offline': 'Offline',
    'header.language': 'Idioma',

    // Dashboard
    'dash.office': 'Gabinete do Treinador',
    'dash.playMatch': 'Jogar jogo',
    'dash.playFirstMatch': 'Joga o teu primeiro jogo',
    'dash.challenge': 'Desafiar',
    'dash.tactics': 'Táticas',
    'dash.invite': 'Convidar',
    'dash.lastMatch': 'Último Jogo',
    'dash.recap': 'Resumo',
    'dash.victory': 'VITÓRIA',
    'dash.defeat': 'DERROTA',
    'dash.draw': 'EMPATE',
    'dash.noMatch': 'SEM JOGOS',
    'dash.noRecentMatches': 'Sem jogos recentes',
    'dash.startJourney': 'Desafia um adversário e mostra o que vales!',
    'dash.playNow': 'Jogar Agora',
    'dash.starPerformer': 'Destaque',
    'dash.noStandout': 'Ainda sem destaque',
    'dash.squadStatus': 'Estado do Plantel',
    'dash.squad': 'PLANTEL',
    'dash.fit': 'Aptos',
    'dash.injured': 'Lesionados',
    'dash.suspended': 'Suspensos',
    'dash.allClear': 'Tudo em ordem · nenhum jogador indisponível',
    'dash.offline': 'Offline',
    'dash.challengeHint': 'Lança um desafio',
    'dash.challengeHintOff': 'Ativa Online no cabeçalho para desafiar',
    'dash.scouting': 'A analisar adversário...',
    'dash.tacticalSetup': 'Estilo Tático · Ativo',
    'dash.style': 'ESTILO',
    'dash.formation': 'Formação',
    'dash.mentality': 'Mentalidade',
    'dash.pressing': 'Pressing',
    'dash.line': 'Linha',
    'dash.tempo': 'Ritmo',

    // Challenges
    'ch.arena': 'Desafios · Arena',
    'ch.title': 'DESAFIOS',
    'ch.league': 'Liga',
    'ch.points': 'Pontos',
    'ch.promotion': 'promoção',
    'ch.today': 'Desafios Hoje',
    'ch.remaining': 'restantes',
    'ch.buyExtra': 'Comprar desafio extra',
    'ch.boughtExtra': 'Desafio extra adicionado!',
    'ch.status': 'Estado',
    'ch.acceptsChallenges': 'aceita desafios',
    'ch.closed': 'fechado',
    'ch.challenge': 'Desafiar',
    'ch.quickMatch': 'Jogo Rápido',
    'ch.randomChallenge': 'Desafio Aleatório',
    'ch.searching': 'A procurar…',
    'ch.mustBeOnline': 'Ativa o teu estado para Online antes de desafiar.',
    'ch.dailyLimit': 'Limite diário de desafios atingido (3/dia).',
    'ch.challengeStartError': 'O desafio foi enviado mas não foi possível abrir o jogo. Vê em Jogos ao vivo / histórico.',
    'ch.toggleError': 'Falha ao alterar o estado. Tenta novamente.',
    'ch.onlineNote': 'Tens de estar Online para desafiar e ser desafiado. Clica no cartão Estado para alternar.',
    'ch.tapToToggle': 'Clica para alternar',

    // Available teams
    'at.title': 'EQUIPAS DISPONÍVEIS',
    'at.subtitle': 'Adversários Disponíveis',
    'at.search': 'Pesquisar por equipa ou treinador...',
    'at.online': 'Online',
    'at.coach': 'Treinador',
    'at.noOpponents': 'Sem adversários disponíveis',
    'at.comeBack': 'Volta depois para encontrar adversários',
    'at.clearSearch': 'Limpar pesquisa',

    // Matches / Histórico
    'mh.archive': 'Arquivo de Jogos · Sector 05',
    'mh.title': 'HISTÓRICO',
    'mh.games': 'Jogos',
    'mh.total': 'total',
    'mh.wins': 'Vitórias',
    'mh.draws': 'Empates',
    'mh.losses': 'Derrotas',
    'mh.wShort': 'V',
    'mh.dShort': 'E',
    'mh.lShort': 'D',
    'mh.winRate': '% taxa de vitória',
    'mh.empty': 'Sem jogos no histórico',
    'mh.emptyHint': 'Os teus jogos aparecerão aqui após o primeiro desafio.',
    'mh.seeMore': 'Ver mais ({count})',
    'mh.seeLess': 'Ver menos',
    'mh.final': 'Final',
    'mh.scheduled': 'Agendado',
    'mh.home': 'Casa',
    'mh.away': 'Fora',

    // Squad / Plantel
    'sq.section': 'Gestão de Plantel · Sector 03',
    'sq.title': 'PLANTEL',
    'sq.size': 'Tamanho',
    'sq.avgOvr': 'Média OVR',
    'sq.value': 'Valor',
    'sq.xi': 'XI Escalado',
    'sq.startingXi': 'Onze Inicial',
    'sq.substitutes': 'Suplentes',
    'sq.reserves': 'Reservas',
    'sq.search': 'Pesquisar plantel...',
    'sq.saveLineup': 'Guardar Alinhamento',
    'sq.noStarters': 'Nenhum jogador no onze inicial',
    'sq.noSubs': 'Nenhum suplente selecionado',
    'sq.noPlayers': 'Nenhum jogador encontrado',
    'sq.scouting': 'A carregar jogadores...',
    'sq.xiInvalid': 'XI inconsistente',
    'sq.xiTooMany': 'Tens {n} jogadores no XI (limite: 11). Clica para corrigir.',
    'sq.xiTooFew': 'Apenas {n}/11 jogadores no XI. Promove reservas para completar.',
    'sq.autofix': 'Auto-corrigir',
    'sq.pos': 'Pos',
    'sq.player': 'Jogador',
    'sq.age': 'Idade',
    'sq.actions': 'Ações',
    'sq.segXi': 'Onze',
    'sq.bench': 'Banco',
    'sq.toXi': '→ Onze',
    'sq.toBench': '→ Banco',
    'sq.toRes': '→ Res',
    'sq.moveTo': 'Mover para',
    'sq.moveAria': 'Mover {name} para: {dest}',
    'sq.actionsFor': 'Ações de {name}',
    'sq.ageShort': '{n}A',
    'sq.inj': 'Lesão',
    'sq.injN': 'Lesão {n}',
    'sq.sus': 'Susp',
    'sq.listedChip': 'À venda',
    'sq.attrs': 'Atributos',
    'sq.aAtk': 'ATA',
    'sq.aPas': 'PAS',
    'sq.aSpd': 'VEL',
    'sq.aDef': 'DEF',
    'sq.aSta': 'RES',
    'sq.aGk': 'GR',
    'sq.fAll': 'Todos',
    'sq.fGK': 'GR',
    'sq.fDEF': 'DEF',
    'sq.fMID': 'MED',
    'sq.fATT': 'AVA',
    'sq.filterPos': 'Filtrar por posição',
    'sq.sort': 'Ordenar',
    'sq.sortAsc': 'Ordem crescente',
    'sq.sortDesc': 'Ordem decrescente',
    'sq.clear': 'Limpar',
    'sq.noMatch': 'Nenhum jogador corresponde a “{q}”',
    'sq.emptyXi': 'Escolhe 11 jogadores do banco ou das reservas.',
    'sq.emptyRes': 'Todos os jogadores estão na convocatória.',
    'sq.showBench': 'Ver banco',
    'sq.saving': 'A guardar…',
    'sq.saved': 'Guardado',
    'sq.saveFailed': 'Falhou',
    'sq.savedOk': 'Alteração guardada.',
    'sq.saveErr': 'Não foi possível guardar.',
    'sq.loadErr': 'Não foi possível carregar o plantel.',
    'sq.notFound': 'Jogador não encontrado.',
    'sq.movedSubsN': 'Jogador movido para o banco. O onze tem agora {n} jogadores.',
    'sq.movedPromoted': 'Jogador movido e um reserva promovido.',
    'sq.noReserves': 'Não há reservas para promover. Promove um reserva antes de tirar este jogador do onze.',
    'sq.gkInXi': 'Já tens um guarda-redes no onze. Move-o primeiro para o banco.',
    'sq.xiExact': 'O onze tem de ter exatamente 11 jogadores.',
    'sq.lineupSaved': 'Alinhamento guardado!',
    'sq.fixedN': '{n} jogadores movidos para o banco.',
    'sq.fixErr': 'Não foi possível corrigir o onze.',
    'sq.listedOk': 'Jogador colocado no mercado.',
    'sq.listErr': 'Não foi possível colocar o jogador à venda.',
    'sq.askPrice': 'Define o preço pedido por {name}.',
    'sq.price': 'Preço (€)',
    'sq.marketValue': 'valor de mercado {v}',
    'sq.priceRange': 'permitido: {min} – {max}',
    'sq.confirmSale': 'Confirmar venda',
    'sq.listing': 'A colocar…',
    'sq.confirmQuick': 'Confirmar · +{v}',

    // Training / Treinos
    'tr.section': 'Centro de Treino · Sector 04',
    'tr.title': 'TREINOS',
    'tr.attribute': 'Atributo',
    'tr.player': 'Jogador',
    'tr.cost': 'Custo',
    'tr.balance': 'Saldo',
    'tr.coins': 'moedas',
    'tr.available': 'disponível',
    'tr.chooseAttr': 'Atributo a treinar',
    'tr.costByPos': 'Custo por Posição',
    'tr.attrCost': 'Atributos & Custo de Treino',
    'tr.costHint': 'Cada treino dá +1 ao atributo. Custo = valor atual × 1000 moedas.',
    'tr.gainInfo': '+1 por treino · máx 99',
    'tr.selectToSeeCosts': 'Seleciona um jogador para ver os atributos e custos.',
    'tr.maxed': 'No máximo',
    'tr.processing': 'A processar...',
    'tr.trainResult': 'Treino! {stat}: {from} → {to}',
    'tr.maxedStat': 'Este atributo já está no máximo (99).',
    'tr.insufficientCoins': 'Moedas insuficientes para este treino.',
    'tr.selectPlayerFirst': 'Seleciona um jogador para treinar.',
    'tr.trainError': 'Ocorreu um erro ao treinar o jogador.',
    'tr.playerSelected': '{name} selecionado!',
    'tr.selectionRemoved': 'Seleção removida.',
    'tr.coinsLoadError': 'Não foi possível carregar as moedas da equipa.',
    'tr.playersLoadError': 'Não foi possível carregar os jogadores do plantel.',
    'tr.trainPlayer': 'Treinar Jogador',
    'tr.selectPlayer': 'Selecionar Jogador',
    'tr.selectHint': 'Seleciona um jogador do teu plantel para treinar',
    'tr.clickSelect': 'Clica para selecionar',
    'tr.noSquadPlayers': 'Nenhum jogador disponível no plantel',
    'tr.clickToChoose': 'Clica para escolher do plantel',
    'tr.scheduled': 'Jogador escalado',
    'tr.train': 'Treinar',
    'tr.cancel': 'Cancelar',
    'tr.trainedTitle': 'Treino concluído',
    'tr.trainedSub': '+1 ponto neste atributo',
    'tr.overall': 'Rating (overall)',
    'tr.cost': 'Custo',
    'tr.continue': 'Continuar',
    'tr.premium': 'Conteúdo Premium',
    'tr.advancedMethods': 'MÉTODOS AVANÇADOS',
    'tr.advancedDesc': 'Desbloqueia programas de treino especializados e acelera o desenvolvimento da equipa.',
    'tr.unlock': 'Desbloquear',
    'tr.includes': 'Treinos táticos, físicos e técnicos',

    // Transfers
    'tf.hub': 'Transferências',
    'tf.manage': 'Gere as transferências e finanças do clube.',
    'tf.budget': 'Orçamento de Transferências',
    'tf.market': 'Mercado',
    'tf.shortlist': 'Favoritos',
    'tf.selling': 'À Venda',
    'tf.history': 'Histórico',
    'tf.searchName': 'Pesquisar nome do jogador...',
    'tf.allPositions': 'Todas as Posições',
    'tf.priceValue': 'Preço / Valor',
    'tf.noMarket': 'Nenhum jogador no mercado com estes critérios.',
    'tf.emptyShortlist': 'A tua lista de favoritos está vazia.',
    'tf.noSelling': 'Nenhum jogador à venda',
    'tf.noSellingHint': 'Lista jogadores no mercado a partir do plantel ou dos detalhes.',
    'tf.forSale': 'À venda',
    'tf.stop': 'Parar',
    'tf.stopSelling': 'Parar de vender',
    'tf.buys': 'Compras',
    'tf.sells': 'Vendas',
    'tf.noHistory': 'Sem {type} no histórico',
    'tf.noTransfers': 'Ainda não fizeste transferências.',
    'tf.sign': 'Contratar',
    'tf.addShortlist': 'Adicionar aos Favoritos',
    'tf.removeShortlist': 'Remover dos Favoritos',
    'tf.signPlayer': 'Contratar Jogador',
    'tf.overall': 'Avaliação Geral',
    'tf.attributes': 'Atributos',
    'tf.currentClub': 'Clube Atual',
    'tf.transferFee': 'Custo de Transferência',
    'tf.coach': 'Treinador',
    'tf.details': 'Detalhes',
    'tf.sell': 'Vender',
    'tf.years': 'anos',

    // Friends
    'fr.network': 'Rede de Amigos',
    'fr.addFriend': 'Adicionar novo amigo',
    'fr.friendEmail': 'Email ou username do treinador',
    'fr.send': 'Enviar Pedido',
    'fr.received': 'Pedidos recebidos',
    'fr.sent': 'Pedidos enviados',
    'fr.myFriends': 'Meus amigos',
    'fr.noPending': 'Nenhum pedido pendente.',
    'fr.noSent': 'Nenhum pedido enviado.',
    'fr.noFriends': 'Ainda não tens amigos adicionados.',
    'fr.count': 'Amigos',
    'fr.pendingCount': 'Pendentes',
    'fr.accept': 'Aceitar',
    'fr.reject': 'Rejeitar',
    'fr.challenge': 'Desafiar',
    'fr.msgChallengeFail': 'Não foi possível desafiar (talvez não esteja na tua liga).',
    'fr.cancel': 'Cancelar',
    'fr.remove': 'Remover',
    'fr.since': 'Desde',
    'fr.available': 'Disponíveis para desafio',
    'fr.noAvailable': 'Nenhum amigo disponível para desafiar.',
    'fr.loading': 'A carregar dados...',
    'fr.privacy': 'Privacidade e segurança',
    'fr.msgInvalidEmail': 'Insere um email ou username válido',
    'fr.msgSent': 'Pedido de amizade enviado com sucesso!',
    'fr.msgSendFail': 'Falha ao enviar pedido',
    'fr.msgNowFriend': 'Já és amigo de {name}!',
    'fr.msgAcceptFail': 'Falha ao aceitar pedido',
    'fr.msgRejected': 'Pedido rejeitado',
    'fr.msgRejectFail': 'Falha ao rejeitar pedido',
    'fr.msgCancelled': 'Pedido cancelado',
    'fr.msgCancelFail': 'Falha ao cancelar pedido',
    'fr.msgRemoved': '{name} foi removido da tua lista de amigos',
    'fr.msgRemoveFail': 'Falha ao remover amigo',

    // League
    'lg.competition': 'Competição · Sector 02',
    'lg.title': 'CLASSIFICAÇÃO',
    'lg.subtitle': 'Acompanha a tua evolução e desafia os melhores treinadores',
    'lg.matchWeek': 'Jornada',
    'lg.standings': 'Classificação · Ao Vivo',
    'lg.table': 'TABELA',
    'lg.clickTeam': 'Clica numa equipa para detalhes',
    'lg.globalStats': 'Estatísticas Globais',
    'lg.h2h': 'Confronto Direto',
    'lg.h2hHint': 'os teus jogos vs esta equipa',
    'lg.last5': 'Últimos 5 jogos',
    'lg.h2hMatches': 'Confrontos diretos',
    'lg.noMatches': 'Sem jogos registados',
    'lg.backendNote': 'Estatísticas globais de outras equipas requerem suporte do backend. Mostrado: confronto direto.',
    'lg.myPos': 'A tua posição',
    'lg.of': 'de',

    // Notifications
    'nt.eyebrow': 'Clube · Alertas',
    'nt.title': 'NOTIFICAÇÕES',
    'nt.inbox': 'CAIXA DE ENTRADA',
    'nt.unread': 'Não lidas',
    'nt.all': 'Todas',
    'nt.filterUnread': 'Não lidas',
    'nt.markAll': 'Marcar todas',
    'nt.empty': 'Sem notificações',
    'nt.delete': 'Apagar',

    // Activity Feed
    'feed.eyebrow': 'Mundo · Ao Vivo',
    'feed.title': 'ATIVIDADE',
    'feed.all': 'Todos',
    'feed.friends': 'Amigos',
    'feed.empty': 'Sem atividade recente',
    'feed.movedTo': 'mudou-se para',
    'feed.unlocked': 'desbloqueou',
    'fr.ranking': 'Ranking de Amigos',
    'fr.you': 'TU',

    // Stats Leaderboards
    'lb.title': 'RANKINGS',
    'lb.eyebrow': 'Rankings Globais · Estatísticas',
    'lb.subtitle': 'Os melhores do mundo — equipas, marcadores e defesas',
    'lb.tabLeague': 'Liga',
    'lb.tabTeams': 'Equipas',
    'lb.tabGoals': 'Marcadores',
    'lb.tabAssists': 'Assistências',
    'lb.tabDefense': 'Defesa',
    'lb.tabRating': 'Rating',
    'lb.team': 'Equipa',
    'lb.player': 'Jogador',
    'lb.played': 'J',
    'lb.wins': 'V',
    'lb.draws': 'E',
    'lb.losses': 'D',
    'lb.points': 'Pts',
    'lb.goalsFor': 'GM',
    'lb.goalsAgainst': 'GS',
    'lb.goalDiff': 'DG',
    'lb.cleanSheets': 'CS',
    'lb.goals': 'Golos',
    'lb.assists': 'Assist.',
    'lb.perMatch': 'p/ Jogo',
    'lb.rating': 'Rating',
    'lb.tackles': 'Desarmes',
    'lb.interceptions': 'Interc.',
    'lb.clearances': 'Cortes',
    'lb.saves': 'Defesas',
    'lb.defScore': 'Score Def.',
    'lb.all': 'Todos',
    'lb.defenders': 'Defesas',
    'lb.goalkeepers': 'Guarda-redes',
    'lb.empty': 'Sem dados ainda — joga mais partidas!',
    'lb.loadFail': 'Erro ao carregar dados',
    'lb.page': 'Página',
    'lb.prev': 'Anterior',
    'lb.next': 'Seguinte',

    // Tactics
    'tc.section': 'Táticas · Sector 06',
    'tc.title': 'TÁTICAS',
    'tc.visualize': 'Visualizar',
    'tc.presets': 'Estilos Rápidos · Estilo de Jogo',
    'tc.presetsHint': 'Configura todos os parâmetros num clique. Depois afina e guarda.',
    'tc.current': 'Atual',
    'tc.dirty': 'Alterações por guardar.',
    'tc.dirtyHint': 'Não te esqueças de clicar em Guardar para aplicar.',
    'tc.saveNow': 'Guardar agora',
    'tc.need11Banner': 'Seleciona os 11 titulares para a tua equipa ficar guardada (faltam {n}).',
    'tc.unsavedTitle': 'Alterações por guardar',
    'tc.unsavedBody': 'Tens alterações nas táticas que ainda não guardaste. Queres guardar antes de sair?',
    'tc.unsavedSave': 'Guardar e sair',
    'tc.unsavedDiscard': 'Sair sem guardar',
    'tc.unsavedCancel': 'Cancelar',
    'tc.mentality': 'Mentalidade',
    'tc.avgRating': 'Rating Médio',
    'tc.status': 'Status',
    'tc.ready': 'Pronto ✓',
    'tc.missing': 'Faltam {n}',
    // Cards / labels da coluna de instruções
    'tc.card.general': 'Filosofia Geral',
    'tc.card.attack': 'Organização Ofensiva',
    'tc.card.defense': 'Estrutura Defensiva',
    'tc.card.setpieces': 'Bolas Paradas',
    'tc.card.takers': 'Batedores Designados',
    'tc.lab.mentality': 'Mentalidade',
    'tc.lab.afterLoss': 'Após Perda',
    'tc.lab.transition': 'Transição',
    'tc.lab.buildup': 'Saída de Bola',
    'tc.lab.style': 'Estilo de Jogo',
    'tc.lab.focus': 'Foco de Jogo',
    'tc.lab.width': 'Largura',
    'tc.lab.tempo': 'Ritmo',
    'tc.lab.passing': 'Passes',
    'tc.lab.crossing': 'Cruzamentos',
    'tc.lab.defLine': 'Linha Defensiva',
    'tc.lab.pressing': 'Pressing',
    'tc.lab.aggression': 'Agressividade',
    'tc.lab.intensity': 'Intensidade',
    'tc.lab.marking': 'Tipo de Marcação',
    'tc.lab.corners': 'Cantos',
    'tc.lab.freekicks': 'Livres',
    'tc.lab.defFocus': 'Foco Defensivo',
    'tc.sp.offensive': 'Ofensivas',
    'tc.sp.defensive': 'Defensivas',
    'tc.tk.penalty': 'Penáltis',
    'tc.tk.corner': 'Cantos',
    'tc.tk.shortFK': 'Livres Curtos',
    'tc.tk.longFK': 'Livres Longos',
    'tc.takersWarn': 'Completa o 11 inicial para configurar os batedores.',
    'tc.selectPlaceholder': 'Selecionar...',
    // Opções (label = display; o value enviado ao backend não muda)
    'tc.o.ment.defensiva': 'Defensiva — Priorizar solidez',
    'tc.o.ment.cautelosa': 'Cautelosa — Equilíbrio defensivo',
    'tc.o.ment.equilibrada': 'Equilibrada — Balanço perfeito',
    'tc.o.ment.positiva': 'Positiva — Buscar o ataque',
    'tc.o.ment.ofensiva': 'Ofensiva — Pressão total',
    'tc.o.loss.recuar': 'Recuar',
    'tc.o.loss.gegenpress': 'Gegenpress',
    'tc.o.trans.lenta': 'Lenta',
    'tc.o.trans.rapida': 'Rápida',
    'tc.o.build.curta': 'Curta — Construir desde trás',
    'tc.o.build.longa': 'Longa — Jogo direto',
    'tc.o.style.passes': 'Jogo de Passes',
    'tc.o.style.contra-ataque': 'Contra-ataque',
    'tc.o.style.organizado': 'Ataque Organizado',
    'tc.o.style.direto': 'Jogo Direto',
    'tc.o.style.alas': 'Pelas Alas',
    'tc.o.style.tiki-taka': 'Tiki-taka',
    'tc.o.focus.lado-esquerdo': 'Lado Esquerdo',
    'tc.o.focus.zona-central': 'Pelo Centro',
    'tc.o.focus.lado-direito': 'Lado Direito',
    'tc.o.focus.misto': 'Misto — Variar',
    'tc.o.width.estreita': 'Estreita',
    'tc.o.width.equilibrada': 'Equilibrada',
    'tc.o.width.larga': 'Larga',
    'tc.o.tempo.baixo': 'Baixo',
    'tc.o.tempo.normal': 'Normal',
    'tc.o.tempo.alto': 'Alto',
    'tc.o.pass.curtos': 'Curtos',
    'tc.o.pass.misto': 'Misto',
    'tc.o.pass.diretos': 'Diretos',
    'tc.o.cross.baixos': 'Baixos',
    'tc.o.cross.misto': 'Misto',
    'tc.o.cross.altos': 'Altos',
    'tc.o.line.baixa': 'Baixa',
    'tc.o.line.media': 'Média',
    'tc.o.line.alta': 'Alta',
    'tc.o.press.baixo': 'Baixo',
    'tc.o.press.medio': 'Médio',
    'tc.o.press.alto': 'Alto',
    'tc.o.aggr.baixa': 'Baixa',
    'tc.o.aggr.moderada': 'Moderada',
    'tc.o.aggr.agressivo': 'Agressiva',
    'tc.o.int.baixa': 'Baixa',
    'tc.o.int.normal': 'Normal',
    'tc.o.int.alta': 'Alta',
    'tc.o.mark.zona': 'Zonal — Por zonas',
    'tc.o.mark.homem': 'Homem-a-homem',
    'tc.o.corn.misto': 'Misto',
    'tc.o.corn.primeiro-poste': 'Primeiro Poste',
    'tc.o.corn.segundo-poste': 'Segundo Poste',
    'tc.o.corn.curtos': 'Curtos',
    'tc.o.fk.direto': 'Direto à Baliza',
    'tc.o.fk.cruzamento': 'Cruzamento',
    'tc.o.fk.curto': 'Curto',
    'tc.o.dfoc.primeiro-poste': 'Primeiro Poste',
    'tc.o.dfoc.segundo-poste': 'Segundo Poste',
    'tc.o.dfoc.centro': 'Centro',
    'tc.o.dfoc.misto': 'Misto',
    'tc.o.dcorn.misto': 'Misto',
    'tc.o.dcorn.zonal': 'Zonal',
    'tc.o.dcorn.homem': 'Homem-a-homem',
    'tc.o.dfk.muralha': 'Muralha',
    'tc.o.dfk.linha-alta': 'Linha Alta',
    'tc.o.dfk.zona': 'Marcação por Zona',
    // Modais de seleção (jogador / batedor)
    'tc.select': 'Selecionar',
    'tc.recommendedFirst': 'Jogadores recomendados aparecem primeiro',
    'tc.viewDetails': 'Clica para ver detalhes',
    'tc.recommended': 'Recomendado',
    'tc.idealPos': 'Posição ideal',
    'dc.eyebrow': 'Bónus diário',
    'dc.toGo': 'Falta {n} para +{coins} moedas',
    'dc.claimed': 'Bónus recebido!',
    'dc.claimedFull': 'Bónus diário recebido — +{coins} moedas 🎉',
    'tc.outOfPosWarn': 'Fora de posição — rating reduzido ~{pct}% no motor.',
    'tc.outOfPosMajorTip': 'Fora de posição · −{pct}%',
    'tc.outOfPosMinorTip': 'Posição específica · −{pct}%',
    'tc.outOfPos': 'Fora de posição',
    'tc.noPlayers': 'Nenhum jogador disponível',
    'tc.lineup': 'Escalar',
    'tc.playerDetail': 'Detalhe do Jogador',
    'tc.close': 'Fechar',
    'tc.cancel': 'Cancelar',
    'tc.tdesc.penalty': 'Alta finalização e compostura sob pressão',
    'tc.tdesc.corner': 'Excelente capacidade de cruzamento e passes',
    'tc.tdesc.freekick': 'Boa técnica de remate e passes precisos',
    'tc.stat.gk': 'Defesa de Baliza',
    'tc.stat.def': 'Defesa',
    'tc.stat.pas': 'Passe',
    'tc.stat.att': 'Ataque',
    'tc.stat.pac': 'Velocidade',
    'tc.stat.sta': 'Resistência',
    // Hint do campo + notificações
    'tc.pitchHint': 'Clica numa posição para escalar um jogador',
    'tc.notif.gkPosOnly': 'Só um guarda-redes pode ocupar a posição GK.',
    'tc.notif.gkPlayerOnly': 'Um guarda-redes só pode jogar na posição GK.',
    'tc.notif.moved': 'Jogador movido para nova posição.',
    'tc.notif.cleared': 'Alinhamento limpo.',
    'tc.notif.injuredCantPlay': 'Jogador lesionado não pode jogar — fica nas reservas até recuperar.',
    'tc.notif.injuredMovedOut': '{n} jogador(es) lesionado(s) removido(s) do onze. Escala um substituto.',
    'tc.injuredTag': 'Lesionado · {n}j',
    'tc.injuredShort': 'Lesionado',
    'tc.injuredCantPlay': 'Lesionado — não pode jogar',
    'tc.notif.need11': 'Erro: seleciona exatamente 11 titulares únicos.',
    'tc.notif.tacticsSavedNeed11': 'Táticas guardadas. O alinhamento precisa de exatamente 11 titulares para ser gravado.',
    'tc.notif.tacticsSavedNoGk': 'Táticas guardadas. O XI precisa de exatamente 1 guarda-redes para gravar o alinhamento.',
    'tc.notif.tacticsSavedManyGk': 'Táticas guardadas. O XI tem {n} guarda-redes (máximo 1) — corrige para gravar o alinhamento.',
    'tc.notif.saved': 'Táticas e equipa guardadas com sucesso!',
    'tc.notif.saveErr': 'Erro ao guardar táticas.',
    'tc.notif.saveLineupErr': 'Erro ao guardar alinhamento.',
    // Visualizer
    'tc.viz.onPitch': 'NO CAMPO',
    'tc.viz.attackUp': 'Ataque para cima ↑',
    'tc.viz.effect': 'Efeito dos parâmetros',
    'tc.lab.attackFocus': 'Foco de Ataque',
    'tc.viz.fx.mentality': 'Posição do bloco no campo',
    'tc.viz.fx.defLine': 'Altura da última linha (tracejado volt)',
    'tc.viz.fx.pressing': 'Zona onde recupera a bola (sombra volt)',
    'tc.viz.fx.width': 'Distância dos corredores ao centro',
    'tc.viz.fx.focus': 'Onde concentra o ataque (alvo)',
    'tc.viz.fx.tempo': 'Velocidade de circulação de bola',
    // Valores extra (largura/foco) para tradução do visualizer
    'tc.v.estreita': 'Estreita',
    'tc.v.equilibrada': 'Equilibrada',
    'tc.v.larga': 'Larga',
    'tc.v.lado-esquerdo': 'Esquerda',
    'tc.v.zona-central': 'Centro',
    'tc.v.lado-direito': 'Direita',
    'tc.v.misto': 'Misto',
    // Formações (nome + descrição)
    'tc.f.4-4-2.name': '4-4-2 Clássico', 'tc.f.4-4-2.desc': 'Equilíbrio clássico.',
    'tc.f.4-3-3.name': '4-3-3 Ataque', 'tc.f.4-3-3.desc': 'Pressão e largura ofensiva.',
    'tc.f.4-2-3-1.name': '4-2-3-1 Controlo', 'tc.f.4-2-3-1.desc': 'Posse e criatividade ofensiva.',
    'tc.f.3-5-2.name': '3-5-2 Dinâmico', 'tc.f.3-5-2.desc': 'Domínio do meio campo com wingbacks avançados.',
    'tc.f.5-3-2.name': '5-3-2 Bloco', 'tc.f.5-3-2.desc': 'Bloco baixo com laterais próximos da defesa.',
    'tc.f.5-4-1.name': '5-4-1 Muralha', 'tc.f.5-4-1.desc': 'Solidez defensiva, transições rápidas.',
    'tc.f.4-1-4-1.name': '4-1-4-1 Compacto', 'tc.f.4-1-4-1.desc': 'Solidez defensiva e transição.',
    'tc.f.4-3-1-2.name': '4-3-1-2 Diamante', 'tc.f.4-3-1-2.desc': 'Jogo interior concentrado.',
    'tc.f.4-4-1-1.name': '4-4-1-1 Suporte', 'tc.f.4-4-1-1.desc': 'Segurança com apoio atrás do avançado.',
    'tc.f.3-4-3.name': '3-4-3 Pressão', 'tc.f.3-4-3.desc': 'Amplitude e pressão constante nas alas.',
    'tc.f.4-2-4.name': '4-2-4 Impacto', 'tc.f.4-2-4.desc': 'Máxima presença ofensiva e largura.',
    'tc.f.3-4-1-2.name': '3-4-1-2 Criativo', 'tc.f.3-4-1-2.desc': 'CAM a servir dois avançados, com wingbacks largos.',
    'tc.f.4-5-1.name': '4-5-1 Densidade', 'tc.f.4-5-1.desc': 'Compactação e paciência ofensiva.',
    'tc.f.4-3-2-1.name': '4-3-2-1 Árvore', 'tc.f.4-3-2-1.desc': 'Meio controlado com dois médios ofensivos.',
    'tc.f.4-2-2-2.name': '4-2-2-2 Duplas', 'tc.f.4-2-2-2.desc': 'Dois CDMs e dois criativos atrás de dois avançados.',
    'tc.f.5-2-3.name': '5-2-3 Transições', 'tc.f.5-2-3.desc': 'Solidez atrás com três na frente.',
    'tc.f.3-2-4-1.name': '3-2-4-1 Fluxo', 'tc.f.3-2-4-1.desc': 'Dois médios de cobertura e quatro à frente.',
    'tc.f.3-5-1-1.name': '3-5-1-1 Equilíbrio', 'tc.f.3-5-1-1.desc': 'Criatividade central com suporte ao ponta.',
    'tc.presetApplied': "Estilo '{name}' aplicado. Lembra-te de guardar.",
    // Presets (estilos de jogo)
    'tc.preset.park-the-bus.label': 'Park the Bus',
    'tc.preset.park-the-bus.desc': 'Defensivo extremo — bloco baixo, contra-ataque',
    'tc.preset.counter-attack.label': 'Contra-Ataque',
    'tc.preset.counter-attack.desc': 'Cautelosa — espera e lança em velocidade',
    'tc.preset.balanced.label': 'Equilibrado',
    'tc.preset.balanced.desc': 'Configuração padrão — adaptável',
    'tc.preset.tiki-taka.label': 'Tiki-Taka',
    'tc.preset.tiki-taka.desc': 'Posse de bola — passes curtos, pressing posicional',
    'tc.preset.gegenpress.label': 'Pressing Alto',
    'tc.preset.gegenpress.desc': 'Klopp style — recupera bola alta com intensidade',
    // Valores táticos (mentalidade / pressing / linha / ritmo)
    'tc.v.defensiva': 'Defensiva',
    'tc.v.cautelosa': 'Cautelosa',
    'tc.v.equilibrada': 'Equilibrada',
    'tc.v.positiva': 'Positiva',
    'tc.v.ofensiva': 'Ofensiva',
    'tc.v.baixo': 'Baixo',
    'tc.v.médio': 'Médio',
    'tc.v.alto': 'Alto',
    'tc.v.baixa': 'Baixa',
    'tc.v.média': 'Média',
    'tc.v.alta': 'Alta',
    'tc.v.normal': 'Normal',

    // Player Stats
    'ps.career': 'Carreira',
    'ps.matches': 'Jogos',
    'ps.goals': 'Golos',
    'ps.assists': 'Assist.',
    'ps.rating': 'Rating',
    'ps.age': 'Idade',
    'ps.country': 'País',
    'ps.height': 'Altura',
    'ps.weight': 'Peso',
    'ps.minutes': 'Minutos',
    'ps.yellow': 'Amarelos',
    'ps.red': 'Vermelhos',
    'ps.passAcc': 'Precisão de Passe',
    'ps.shotAcc': 'Precisão de Remate',
    'ps.recentForm': 'Forma Recente',
    'ps.noStats': 'Estatísticas de carreira indisponíveis para este jogador.',

    // Game Loading
    'game.loadingTitle': 'A iniciar simulação...',
    'game.stepUser': 'Carregar utilizador',
    'game.stepTeam': 'Sincronizar equipa',
    'game.stepPlayers': 'Carregar plantel',
    'game.stepFinish': 'Pronto',
    'game.error': 'Erro ao carregar equipa',

    // Shop
    'shop.vault': 'Cofre · Investimento',
    'shop.title': 'LOJA DO CLUBE',
    'shop.subtitle': 'Investe no futuro do teu clube.',
    'shop.buy': 'Comprar',
    'shop.pack.small': 'Investimento Inicial',
    'shop.pack.medium': 'Patrocínio Local',
    'shop.pack.big': 'Injeção Financeira',
    'shop.pack.pro': 'Investidor Anjo',
    'shop.pack.elite': 'Xeque Árabe',
    'shop.pack.mega': 'Dono Bilionário',
    // Shop — gold coins, conversão, itens, desafios
    'shop.balance': 'Saldo',
    'shop.coins': 'Dinheiro',
    'shop.inSquadNote': 'Os jogadores já estão no teu plantel (reservas).',
    'shop.goToSquad': 'Ir para o plantel',
    'shop.gold': 'Gold Coins',
    'shop.goldPacks': 'Comprar Gold Coins',
    'shop.goldPacksHint': 'Pagas com dinheiro real (Stripe). Usa as gold coins para desafios extra e ligas privadas.',
    'shop.convert': 'Converter Moedas → Gold',
    'shop.convertHint': 'Troca dinheiro do clube por gold (€{rate} = 1 gold).',
    'shop.convertAmount': 'Gold a receber',
    'shop.convertCost': 'Custo',
    'shop.convertBtn': 'Converter',
    'shop.extra': 'Desafios Extra',
    'shop.extraHint': 'Cada slot extra custa {coins} moedas ou {gold} gold.',
    'shop.buyWithCoins': 'Pagar com moedas',
    'shop.buyWithGold': 'Pagar com gold',
    'shop.items': 'Itens',
    'shop.noItems': 'Sem itens disponíveis de momento.',
    'shop.buyReal': 'Comprar',
    'shop.purchaseOk': 'Compra concluída!',
    'shop.purchaseErr': 'Não foi possível concluir a compra.',
    'shop.insufficient': 'Saldo insuficiente.',
    'shop.redirecting': 'A redirecionar para o pagamento...',
    'shop.playerPacks': 'Packs de Jogadores',
    'shop.playerPacksHint': 'Abre um pack e recebe jogadores aleatórios dentro do overall do pack.',
    'shop.buyCoins': 'Comprar Dinheiro',
    'shop.buyCoinsHint': 'Reforça o orçamento do clube com dinheiro real (Stripe).',
    'shop.packsUnavailable': 'Indisponível de momento. (backend: GET /store/packs)',
    'shop.openPack': 'Abrir Pack',
    'shop.tapToOpen': 'Toca para abrir',
    'shop.revealNext': 'Próxima carta',
    'shop.packResult': 'Novos jogadores',
    'shop.continue': 'Continuar',
    'shop.opening': 'A abrir...',
    'shop.cardOne': 'CARTA',
    'shop.cards': 'CARTAS',
    'shop.packTier.bronze': 'Pack Bronze',
    'shop.packTier.silver': 'Pack Prata',
    'shop.packTier.gold': 'Pack Ouro',
    'shop.packTier.diamond': 'Pack Diamante',
    'shop.packDesc': 'Recebe {n} jogador(es) · OVR {min}–{max}',
    'shop.extraName': 'Desafio Extra',
    'shop.extraDesc': '+1 slot de desafio',
    // Ligas Privadas
    'nav.leagues': 'Ligas Privadas',
    'pl.section': 'Ligas Privadas · Arena Social',
    'pl.title': 'LIGAS PRIVADAS',
    'pl.subtitle': 'Cria ou junta-te a ligas com os teus amigos.',
    'pl.create': 'Criar Liga',
    'pl.createHint': 'Cria uma liga e partilha o código de convite.',
    'pl.leagueName': 'Nome da liga',
    'pl.createBtn': 'Criar',
    'pl.join': 'Entrar com Código',
    'pl.joinHint': 'Tens um código de convite? Junta-te aqui.',
    'pl.inviteCode': 'Código de convite',
    'pl.joinBtn': 'Entrar',
    'pl.myLeagues': 'As Minhas Ligas',
    'pl.noLeagues': 'Ainda não estás em nenhuma liga privada.',
    'pl.noStandings': 'Sem jogos ainda — partilha o código para os amigos entrarem e começarem a jogar.',
    'pl.stRecruiting': 'A recrutar',
    'pl.stActive': 'A decorrer',
    'pl.stCompleted': 'Terminada',
    'pl.stCancelled': 'Cancelada',
    'pl.prize': 'Prémio',
    'pl.recruitEndsIn': 'Recruta acaba em',
    'pl.endsIn': 'Termina em',
    'pl.dailyChallenges': 'Desafios hoje',
    'pl.challengeBtn': 'Desafiar',
    'pl.you': 'TU',
    'pl.winnerIs': '🏆 Campeão: {name}',
    'pl.recruitingHint': 'À espera de membros — precisas de 3+ em 24h, senão a liga é cancelada e o ouro devolvido.',
    'pl.noDailyLeft': 'Sem desafios de liga disponíveis hoje. Volta amanhã.',
    'pl.cantLeaveActive': 'Não podes sair com a época a decorrer.',
    'pl.duration': 'Duração',
    'pl.durationLabel': 'Duração da época',
    'pl.daysShort': 'd',
    'pl.maxMembers': 'Máx. membros',
    'pl.createFieldsHint': 'Duração da época e nº máximo de jogadores que podem entrar.',
    'pl.createPrizeNote': 'No fim da época, o 1º classificado ganha um prémio em gold + moedas.',
    'pl.copy': 'Copiar código',
    'pl.share': 'Partilhar',
    'pl.shareText': 'Junta-te à minha liga "{name}" no My Football Game! Código de convite: {code}',
    'pl.shareCopied': 'Código copiado — partilha com os teus amigos!',
    'pl.champPrize': 'Prémio do campeão',
    'pl.matchHistory': 'Histórico de jogos',
    'pl.prizeWinnerOnly': 'Só o 1º classificado no fim da época recebe. Mais ninguém.',
    // Live Match Viewer
    'lmv.matchCenter': 'Centro de Jogo',
    'lmv.ft': 'FIM',
    'lmv.htShort': 'INT',
    'lmv.fullTime': 'Final do jogo',
    'lmv.firstHalf': '1ª parte',
    'lmv.secondHalf': '2ª parte',
    'lmv.kickoff': 'Início do jogo',
    'lmv.momentum': 'Pressão ofensiva',
    'lmv.assist': 'Assistência: {player}',
    'lmv.skip': 'Saltar para o fim',
    'lmv.continue': 'Continuar',
    'lmv.potm': 'Melhor em campo',
    'lmv.bench': 'Suplentes',
    'lmv.noLineups': 'Escalações indisponíveis para este jogo.',
    'lmv.ratingsAtFt': 'As avaliações aparecem no fim do jogo.',
    'lmv.aPlayer': 'um jogador',
    'lmv.tab.feed': 'Relato',
    'lmv.tab.stats': 'Estatísticas',
    'lmv.tab.lineups': 'Equipas',
    'lmv.type.season': 'Campeonato',
    'lmv.type.challenge': 'Jogo rápido',
    'lmv.type.tournament': 'Torneio',
    'lmv.type.league_challenge': 'Liga privada',
    'lmv.type.link_challenge': 'Desafio por link',
    'lmv.st.shots': 'Remates',
    'lmv.st.possession': 'Posse de bola',
    'lmv.st.xg': 'Golos esperados (xG)',
    'lmv.st.on_target': 'Remates à baliza',
    'lmv.st.corners': 'Cantos',
    'lmv.st.free_kicks': 'Livres',
    'lmv.st.offsides': 'Foras de jogo',
    'lmv.st.saves': 'Defesas',
    'lmv.st.yellow': 'Cartões amarelos',
    'lmv.st.red': 'Cartões vermelhos',
    'lmv.pos.Goalkeeper': 'GR',
    'lmv.pos.Defender': 'DEF',
    'lmv.pos.Midfielder': 'MED',
    'lmv.pos.Forward': 'AV',
    'lmv.c.goal.0': 'GOLO! {player} marca para o {team}!',
    'lmv.c.goal.1': '{player} não perdoa e faz o golo do {team}!',
    'lmv.c.goal.2': 'Golo do {team}! Remate certeiro de {player}.',
    'lmv.c.own_goal.0': 'Autogolo de {player}! Infelicidade para o {team}.',
    'lmv.c.save.0': 'Grande defesa de {player}! O {opp} esteve perto.',
    'lmv.c.save.1': '{player} voa e nega o golo ao {opp}.',
    'lmv.c.save.2': 'Remate do {opp}, {player} segura sem problemas.',
    'lmv.c.miss.0': '{player} remata... ao lado!',
    'lmv.c.miss.1': 'Oportunidade para o {team}, mas {player} atira por cima.',
    'lmv.c.miss.2': '{player} tenta a sorte, sem pontaria.',
    'lmv.c.block.0': 'Remate do {opp} bloqueado por {player}.',
    'lmv.c.block.1': '{player} atira-se à bola e trava o {opp}.',
    'lmv.c.offside.0': 'Fora de jogo assinalado a {player}.',
    'lmv.c.offside.1': 'Bandeirola no ar: {player} em posição irregular.',
    'lmv.c.corner.0': 'Canto para o {team}.',
    'lmv.c.corner.1': 'O {team} ganha um canto, mas a defesa afasta.',
    'lmv.c.free_kick.0': 'Livre para o {team}, sem perigo.',
    'lmv.c.free_kick.1': 'O {team} cobra o livre e a defesa resolve.',
    'lmv.c.yellow_card.0': 'Amarelo para {player} ({team}).',
    'lmv.c.yellow_card.1': 'O árbitro mostra o cartão amarelo a {player}.',
    'lmv.c.red_card.0': 'Vermelho! {player} é expulso e o {team} fica com dez.',
    'lmv.c.injury.0': '{player} está lesionado e recebe assistência.',
    'lmv.c.injury.1': 'Preocupação no {team}: {player} ficou queixoso.',
    'lmv.c.substitution.0': 'Substituição no {team}: entra {in}, sai {out}.',
    'lmv.c.penalty_scored.0': 'Penálti convertido por {player}!',
    'lmv.c.penalty_missed.0': 'Penálti falhado por {player}!',
    'lmv.reconnect': 'Reconectar',
    'lmv.halftime': 'Intervalo',
    'lmv.startingSoon': 'O jogo vai começar',
    'lmv.underway': 'Jogo a decorrer — sem lances ainda',
    'lmv.leave': 'Sair do Jogo',
    'lmv.forfeitTitle': 'Abandonar Partida?',
    'lmv.forfeitBody': 'Se sair agora, será contabilizado como',
    'lmv.forfeitLoss': 'derrota por 3-0',
    'lmv.forfeitConfirm': 'Sim, Desistir',
    'lmv.forfeitCancel': 'Continuar a Jogar',
    // Broadcast Moments
    'mm.goal': 'GOLOOOO!',
    'mm.ownGoal': 'AUTO-GOLO',
    'mm.save': 'DEFESA!',
    'mm.penalty': 'PENÁLTI!',
    'mm.offside': 'FORA DE JOGO',
    'mm.yellow': 'AMARELO',
    'mm.red': 'EXPULSÃO',
    'mm.sub': 'SUBSTITUIÇÃO',
    'mm.miss': 'POR POUCO!',
    'mm.block': 'BLOQUEADO!',
    'mm.kickoff': 'COMEÇA O JOGO',
    'mm.fulltime': 'FIM DO JOGO',
    'mm.live': 'AO VIVO',
    'mm.lastPlay': 'Última jogada',
    'mm.noPlaysYet': 'Bola a rolar — sem lances ainda',
    'pl.members': 'membros',
    'pl.owner': 'Dono',
    'pl.standings': 'Classificação',
    'pl.team': 'Equipa',
    'pl.played': 'J',
    'pl.win': 'V',
    'pl.draw': 'E',
    'pl.loss': 'D',
    'pl.gd': 'DG',
    'pl.points': 'Pts',
    'pl.copyCode': 'Copiar código',
    'pl.copied': 'Copiado!',
    'pl.leave': 'Sair da liga',
    'pl.delete': 'Apagar liga',
    'pl.kick': 'Expulsar',
    'pl.back': 'Voltar',
    'pl.createdOk': 'Liga criada! Código: {code}',
    'pl.joinedOk': 'Entraste na liga!',
    'pl.leftOk': 'Saíste da liga.',
    'pl.errGeneric': 'Algo correu mal. Tenta de novo.',
    'pl.costNote': 'Criar uma liga custa {gold} gold coins.',
    'pl.noGold': 'Não tens gold suficiente para criar a liga.',

    // Auth & Registo
    'reg.title': 'CRIAR CONTA',
    'reg.subtitle': 'Começa a tua carreira na secção desportiva.',
    'reg.step1': 'Autenticação',
    'reg.step2': 'Criar Equipa',
    'reg.teamName': 'Nome da Equipa',
    'reg.username': 'O teu nome (Treinador)',
    'reg.email': 'Email',
    'reg.password': 'Palavra-passe',
    'reg.confirmPass': 'Confirmar',
    'reg.agree': 'Concordo com os ',
    'reg.terms': 'Termos e Condições',
    'reg.back': 'Voltar',
    'reg.next': 'Continuar →',
    'reg.create': 'Estabelecer Clube',
    'reg.creating': 'A processar...',
    'reg.hasAccount': 'Já conheces o terminal?',
    'reg.login': 'Entrar aqui',

    // Login
    'login.title': 'BEM-VINDO DE VOLTA',
    'login.subtitle': 'Acede à gestão do teu clube.',
    'login.email': 'Email',
    'login.password': 'Palavra-passe',
    'login.remember': 'Manter sessão iniciada',
    'login.submit': 'ACEDER AO SISTEMA',
    'login.loading': 'A verificar credenciais...',
    'login.noAccount': 'Ainda não tens estatuto de treinador?',
    'login.register': 'Regista-te aqui',
    'reg.emailIsRequired': 'Email obrigatório',
    'reg.coachNameIsRequired': 'Nome do treinador obrigatório',
    'reg.teamNameIsRequired': 'Nome da equipa obrigatório',
    'reg.invalidEmail': 'Email inválido',
    'reg.passwordMustBeAt': 'Palavra-passe mínimo 6 caracteres',
    'reg.registrationFailedPleaseTry': 'Registo falhou. Tenta novamente.',
    'reg.play': 'JOGAR',
    'reg.now': 'AGORA',
    'reg.freeNoDownload30': 'Grátis · Sem download · 30 segundos',
    'reg.100CoachesPlaying': '100+ treinadores a jogar',
    'reg.signingIn': 'A entrar...',
    'reg.signUpWithGoogle': 'Registar com Google',
    'reg.1ClickTeamAuto': '1 clique · equipa gerada automaticamente',
    'reg.orSignUpWith': '— ou registar com email —',
    'reg.email2': 'email',
    'reg.password2': 'Palavra-passe',
    'reg.min6Characters': 'Mínimo 6 caracteres',
    'reg.coachName': 'Nome do Treinador',
    'reg.eGAlexFerguson': 'ex: José Mourinho',
    'reg.teamName2': 'Nome da Equipa',
    'reg.eGThunderFc': 'ex: Porto FC',
    'reg.inviteCodeOptional': 'Código de convite (opcional)',
    'reg.invalidCode': 'Código inválido',
    'reg.creating2': 'A criar...',
    'reg.createTeam': 'Criar Equipa',
    'reg.bySigningUpYou': 'Ao registar, concordas com os ',
    'reg.marketingConsent': 'Envia-me novidades do jogo por email. Podes cancelar a qualquer momento.',
    'login.signingIn': 'A entrar...',
    'login.continueWithGoogle': 'Continuar com Google',
    'login.orWithEmail': 'ou com email',
    'wel.yourFirstMatchIs': 'O teu primeiro jogo já está a ser simulado!',
    'wel.yourTeamIsReady': 'A tua equipa está pronta e o teu primeiro jogo já foi lançado! Vê o resultado no dashboard.',
    'wel.goToDashboard': 'Ver Dashboard',
    'com.inviteFriends': 'CONVIDA AMIGOS',
    'com.earnRewards': 'Ganha Recompensas',
    'com.youGet50kCoins': 'Tu ganhas 50K moedas + 5 gold',
    'com.whenYourFriendPlays': 'quando o teu amigo joga o primeiro jogo.',
    'com.yourFriendGets25k': 'O teu amigo recebe 25K moedas ao registar-se.',
    'com.code': 'CÓDIGO',
    'com.shareInvite': 'Partilhar',
    'com.copied': 'Copiado!',
    'com.invited': 'Convidados',
    'com.active': 'Ativos',
    'com.earned': 'Ganhos',
    'com.referralSystemUnavailable': 'Sistema de referências indisponível.',
    'com.community': 'COMUNIDADE',
    'com.joinUs': 'Junta-te a Nós',
    'com.chatChallengesCommunityTips': 'Chat, desafios e dicas da comunidade',
    'reg.features': '18 formações táticas|Mercado de transferências|Jogos em tempo real|Ligas privadas',
    'reg.invitedBy': '✓ Convidado por {coach} — recebes 25K coins!',
    'com.shareText': 'Joga comigo no My Football Game! Usa o código {code} e ganha 25K moedas de bónus ⚽🪙',
    'av.noneFound': 'Nenhuma equipa encontrada',
    'av.tryAnother': 'Tenta outro nome',
    'ts.saving': 'A guardar...',
    'ts.serverTooBig': 'O logótipo é demasiado grande para o servidor. Tenta outra imagem ou cola um URL.',
    'tour.knockout': 'Eliminatórias',
    'go.gameOver': 'Fim de jogo',
    'go.finalStats': 'As tuas estatísticas finais',
    'go.seasons': 'Épocas como treinador',
    'go.finalPosition': 'Posição final',
    'go.shareTwitter': 'Partilhar no Twitter',
    'go.shareFacebook': 'Partilhar no Facebook',
    'go.shareReddit': 'Partilhar no Reddit',
    'go.shareWhatsapp': 'Partilhar no WhatsApp',
    'go.copyResult': 'Copiar resultado',
    'go.betterLuck': 'Mais sorte no próximo clube! Pronto para outro desafio?',
    'go.feedbackTitle': 'A tua opinião conta!',
    'go.fbGeneral': 'Opinião geral',
    'go.fbGameplay': 'Jogabilidade',
    'go.fbDifficulty': 'Dificuldade',
    'go.fbBugs': 'Erros/Problemas',
    'go.fbSuggestions': 'Sugestões',
    'go.fbOther': 'Outro',
    'go.fbPlaceholder': 'Do que gostaste ou não gostaste? Alguma sugestão?',
    'go.thanks': 'Obrigado!',
    'go.thanksBody': 'A tua opinião foi enviada. Obrigado!',
    'rev.financial': 'Impacto financeiro',
    'rev.reputation': 'Alteração de reputação',
    'rev.percentage': 'Variação percentual',
    'rev.impact': 'Impacto do evento',
    'rev.attention': 'Este evento requer a tua atenção. Como queres avançar?',
    'av.eyebrow': 'Adversários disponíveis',
    'av.title': 'EQUIPAS DISPONÍVEIS',
    'av.search': 'Pesquisar por equipa ou treinador...',
    'av.coach': 'Treinador',
    'av.challenging': 'A desafiar...',
    'av.challenge': 'Desafiar',
    'av.loadError': 'Erro ao carregar equipas disponíveis',
    'av.dailyLimit': 'Limite diário de desafios atingido! Podes enviar 3 desafios por dia.',
    'av.noneAvailable': 'Sem oponentes disponíveis',
    'av.comeBack': 'Volta depois para encontrar oponentes',
    'set.inviteFriends': 'Convida amigos',
    'set.inviteBody': 'Partilha o teu código: ganhas 50K moedas + 5 gold quando o teu amigo joga o primeiro jogo. Ele recebe 25K moedas de bónus ao registar-se!',
    'set.yourCode': 'O teu código de convite',
    'set.playing': 'A jogar',
    'set.recentInvites': 'Convites recentes',
    'mr.timeline': 'Cronologia do jogo',
    'mr.comparison': 'Comparação das equipas',
    'mr.points': 'Pontos ganhos',
    'mr.fans': 'Felicidade dos adeptos',
    'mr.revenue': 'Receita do jogo',
    'mr.scorers': 'Os teus marcadores',
    'cmr.injured': 'Jogador lesionado!',
    'cmr.leaguePoints': 'Pontos liga',
    'cmr.coins': 'Moedas',
    'ts.title': 'Definições do clube',
    'ts.teamName': 'Nome da equipa',
    'ts.clubName': 'Nome do clube',
    'ts.pasteUrl': '…ou colar URL da imagem',
    'ts.save': 'Guardar',
    'ts.loadError': 'Falha ao carregar dados da equipa.',
    'ts.pickImage': 'Escolhe um ficheiro de imagem.',
    'ts.tooBig': 'Imagem demasiado grande (máx 10MB).',
    'ts.readError': 'Não foi possível ler a imagem.',
    'ts.invalidImage': 'Imagem inválida.',
    'ts.processError': 'Não foi possível processar a imagem.',
    'ts.saveError': 'Falha ao guardar.',
    'mh.eyebrow': 'Treinador',
    'mh.morale': 'Moral',
    'mh.keepPlaying': 'Continua a jogar para subir de nível!',
    'mh.objectivesSoon': 'Os objetivos da época vão aparecer em breve',
    'mh.overview': 'Resumo',
    'mh.training': 'Treino',
    'mh.objectives': 'Objetivos',
    'tour.eyebrow': 'Competitivo',
    'tour.teams': 'Equipas',
    'tour.entryFee': 'Inscrição',
    'tour.prizePool': 'Prémios',
    'tour.format': 'Formato',
    'tour.prizeDistribution': 'Distribuição de prémios',
    'tour.bracket': 'Quadro',
    'mis.none': 'Ainda não há missões disponíveis',
    'mis.weekly': 'Semanal',
    'mis.allDone': 'Todas as missões concluídas!',
    'sq.sellPlayer': 'Vender jogador',
    'tac.player': 'Jogador',
    'tac.attributes': 'Atributos',
    'tac.preview': 'Pré-visualização tática',
    'tac.startersSet': 'Titulares escalados',
  },
  en: {
    // Welcome (first launch)
    'wel.eyebrow': 'Welcome to My Football Game',
    'wel.title': 'Your team is ready!',
    'wel.squadReady': "We've created a starter team with a full squad — it's already in your Squad, ready to play.",
    'wel.squad': 'Squad: manage your eleven, subs and reserves.',
    'wel.tactics': 'Tactics: pick your formation and play style.',
    'wel.challenge': 'Challenges: play other teams and climb the league.',
    'wel.shop': 'Shop: open player packs with gold.',
    'wel.seeSquad': 'See my squad',
    'wel.explore': 'Explore first',
    // Nav & General
    'nav.dashboard': 'Home',
    'nav.squad': 'Squad',
    'sq.swapped': '{in} into the XI; {out} to the bench.',
    'sq.xiFull': 'The eleven is full — promote and we swap automatically, or move a starter out.',
    'sq.injuredBlock': 'Injured player — can only stay in the reserves.',
    'sq.injuredBlockN': 'Injured player ({n} games) — can only stay in the reserves.',
    'sq.sell': 'Sell',
    'sq.modifyListing': 'Modify price',
    'sq.quickSell': 'Quick sell',
    'sq.quickSellHint': 'Sell now for 60% of market value.',
    'sq.sellHint': 'Move out of the eleven/bench to sell.',
    'sq.soldFor': '{name} sold for €{coins}.',
    'sq.sold': 'Player sold.',
    'sq.sellErr': "Couldn't sell.",

    'nav.training': 'Training',
    'nav.tactics': 'Tactics',
    'nav.transfers': 'Transfers',
    'nav.league': 'League',
    'nav.leaderboard': 'Leaderboard',
    'nav.challenges': 'Challenges',
    'nav.friends': 'Friends',
    'nav.matches': 'Matches',
    'nav.shop': 'Shop',
    'nav.settings': 'Settings',
    'nav.menu': 'Menu',
    // Settings
    'set.section': 'Account · Settings',
    'set.title': 'SETTINGS',
    'set.subtitle': 'Manage your account, club data and preferences.',
    'set.profile': 'Profile',
    'set.email': 'Email',
    'set.coachName': 'Coach name',
    'set.clubName': 'Club name',
    'set.save': 'Save',
    'set.saved': 'Saved!',
    'set.coachNameNote': 'Changing the coach name needs a backend endpoint.',
    'set.preferences': 'Preferences',
    'tour.dashboard': "Home — your office: budget, rank and next match.",
    'tour.squad': 'Squad — manage your eleven, subs and reserves; sell players.',
    'tour.tactics': 'Tactics — pick your formation and play style.',
    'tour.league': 'League — play challenges and climb the table.',
    'tour.menu': 'Menu — shop, private leagues, friends and settings.',
    'tour.next': 'Next',
    'tour.done': "Let's go!",
    'notif.promptTitle': 'Enable notifications?',
    'notif.promptBody': 'Get alerts when you are challenged, with match results and on player sales.',
    'notif.promptYes': 'Enable notifications',
    'notif.promptNo': 'Not now',
    'set.coachName': 'Coach name',
    'set.renameToken': 'Rename',
    'set.coachTokenNote': 'Requires a “Coach Rename Token” (buy in the Shop, 100 gold).',
    'set.coachRenamed': 'Coach renamed!',
    'set.needCoachToken': 'You need a Coach Rename Token. Buy it in the Shop.',
    'set.notifications': 'Notifications',
    'set.notifPush': 'Device notifications',
    'set.notifOn': 'On — you get challenge, result and sale alerts.',
    'set.notifOff': 'Off. Enable to receive alerts.',
    'set.notifBlocked': 'Blocked in the browser. Enable in site settings.',
    'set.notifActive': 'Active',
    'set.notifEnable': 'Enable',
    'set.notifRecent': 'Recent',
    'set.notifMarkAll': 'Mark all read',
    'set.notifEmpty': 'No notifications.',
    'set.language': 'Language',
    'set.account': 'Account',
    'set.logout': 'Log out',
    'set.logoutHint': 'Sign out of your account on this device.',
    'set.changePassword': 'Change password',
    'set.changePasswordHint': 'We send a reset link to your email.',
    'set.passwordEmailSent': 'Reset email sent!',
    'set.deleteAccount': 'Delete account',
    'set.deleteHint': 'Permanently delete the account and all data. Irreversible.',
    'set.deleteConfirmTitle': 'Delete account?',
    'set.deleteConfirmBody': 'This is permanent and erases your team, players and history. Confirm with your password.',
    'set.passwordPlaceholder': 'Your password',
    'set.deleteBtn': 'Delete permanently',
    'set.cancel': 'Cancel',
    'set.errGeneric': 'Something went wrong. Try again.',
    'set.emailInUse': 'That email is already in use.',
    'nav.home': 'Home',
    'nav.section': 'Navigation',
    'share.result': 'Share result',
    'share.won': 'I beat {opp} {score} ⚽ Think you can do better?',
    'share.drew': 'I drew {score} with {opp} ⚽ Think you can do better?',
    'share.lost': 'Lost {score} to {opp}... think you can do better? ⚽',
    'share.winPrompt': 'You won {score}! Dare a friend to do better against your club.',
    'share.challenge': 'Challenge a friend',
    'share.share': 'Share',
    'share.via': 'Share via',
    'share.copyLink': 'Copy link',
    'share.copied': 'Copied!',
    'cl.email': 'Email',
    'cl.password': 'Password (min. 6)',
    'cl.coachName': 'Manager name (optional)',
    'cl.save': 'Save my club',
    'cl.saveGoogle': 'Save with Google',
    'cl.orEmail': 'or with email',
    'cl.claimError': "Couldn't save your club.",
    'cl.notFound': "This challenge doesn't exist or has expired.",
    'cl.playError': "Couldn't start the match.",
    'cl.discover': 'Discover the game',
    'cl.challengedBy': '{coach} challenges you!',
    'cl.record': '{w}W {d}D {l}L',
    'cl.plays': '{n} challenges accepted',
    'cl.pitch': 'Get a squad in a second and play this club right now.',
    'cl.yourTeam': 'Your team name (optional)',
    'cl.playNow': 'Accept the challenge',
    'cl.playWithMyClub': 'Play with my club',
    'cl.noSignup': 'Free, no signup, plays in your browser.',
    'cl.keepTitle': 'Save your club',
    'cl.keepBody': 'Keep your team, become friends with {coach} and play your own season.',
    'cl.keepBodyGame': "You're playing as a guest. Save your club so you don't lose your team or results.",
    'cl.continueGuest': 'Continue as guest',
    'cl.goToGame': 'Go to the game',
    'cl.rematch': 'Rematch',
    'cl.guestBanner': "You're playing as a guest. Save your club so you don't lose it.",
    'inv.title': 'Challenge friends with a link',
    'inv.body': 'They open the link and play your club instantly, no signup.',
    'inv.share': 'Share',
    'inv.copy': 'Copy',
    'inv.copied': 'Copied!',
    'inv.error': "Couldn't create the link.",
    'inv.message': "Bet you can't beat {team} ⚽ Play now, no signup:",
    'inv.passOnTitle': 'Your turn to challenge',
    'inv.passOnBody': 'You have your own club now. Send the link to a friend and see if they can beat you.',
    'h2h.title': 'Head to head',
    'h2h.wdl': 'W-D-L',
    'h2h.played': '{n} played',
    'h2h.goals': 'Goals {gf}-{ga}',
    'h2h.recent': 'Recent matches',
    'h2h.never': "You haven't played {name} yet. Time to fix that!",
    'h2h.revenge': 'Get revenge!',
    'h2h.challenge': 'Challenge {name}',
    'h2h.short': 'Vs you:',
    'h2h.noneYet': 'No matches between you yet',
    'h2h.loadError': "Couldn't load the head-to-head.",
    'h2h.r.W': 'W',
    'h2h.r.D': 'D',
    'h2h.r.L': 'L',
    'rk.title': 'Ranked League',
    'rk.subtitle': 'Challenge other managers, earn points and climb the divisions.',
    'rk.you': 'YOU',
    'rk.played': '{n} played',
    'rk.of': 'of {n}',
    'rk.toPromotion': '{n} pts to reach {league}',
    'rk.topLeague': 'You are in the top division. Defend your place!',
    'rk.jumpToMe': 'Jump to my position',
    'rk.club': 'Club',
    'rk.p': 'P',
    'rk.wdl': 'W-D-L',
    'rk.pts': 'Pts',
    'rk.empty': 'No teams in this division yet.',
    'rk.loadError': "Couldn't load the standings.",
    'rk.range': '{from}–{to} of {total}',
    'rk.howItWorks': 'Wins are worth up to 4 pts, draws 1, defeats cost 1. Hit the division target to get promoted.',
    'nav.season': 'Season',
    'se.loadError': "Couldn't load your season.",
    'se.playError': "Couldn't start the match.",
    'se.retry': 'Try again',
    'se.seasonN': 'Season {n}',
    'se.seasonOver': 'Season over',
    'se.matchdayOf': 'Matchday {n}/{total}',
    'se.openTactics': 'Open Tactics',
    'se.derby': 'Derby',
    'se.friend': 'Friend',
    'se.obj.top_eight': 'Finish {pos} or better',
    'se.boardReaction': 'Board reaction',
    'se.continue': 'Continue',
    'se.result.win': 'Win',
    'se.result.draw': 'Draw',
    'se.result.loss': 'Defeat',
    'se.nextVs': 'MD{md} · {where} vs {opp}',
    'se.tone.thrashing': 'What a performance! That is how it is done, boss.',
    'se.tone.statement_win': 'A statement win against {opp}. You showed what we can do.',
    'se.tone.expected_win': 'The result we expected. Keep it going.',
    'se.tone.good_draw': 'A useful point against {opp}. We will take it.',
    'se.tone.poor_draw': 'A draw with {opp}? We expected more.',
    'se.tone.tough_loss': 'A defeat to a strong side. We understand, but it cannot become a habit.',
    'se.tone.bad_loss': 'Losing to {opp} is unacceptable.',
    'se.tone.humiliation': 'A humiliation. The fans deserve better.',
    'se.autoFilled': 'Injuries or suspensions left gaps in your XI. Your assistant picked: {names}.',
    'se.nextMatch': 'Next match',
    'se.home': 'Home',
    'se.away': 'Away',
    'se.watchMatch': 'Watch match in progress',
    'se.playMatchday': 'Play matchday {n}',
    'se.rewards': 'Win +{win} · Draw +{draw} coins',
    'se.finalStanding': 'Final standing',
    'se.outcome.champion': 'Champions!',
    'se.outcome.promoted': 'Promoted!',
    'se.outcome.relegated': 'Relegated',
    'se.outcome.stayed': 'Stayed up',
    'se.nextDivision': 'Next season: {name}',
    'se.prizeWon': 'Season prize: +{coins} coins',
    'se.prizeNone': 'No prize this season.',
    'se.startSeason': 'Start season {n}',
    'se.board': 'Board',
    'se.mood.delighted': 'Delighted',
    'se.mood.pleased': 'Pleased',
    'se.mood.neutral': 'Neutral',
    'se.mood.concerned': 'Concerned',
    'se.mood.furious': 'Furious',
    'se.expectation': 'The board expects:',
    'se.obj.title': 'Win the league',
    'se.obj.promotion': 'Promotion (top {n})',
    'se.obj.top_three': 'Finish top 3',
    'se.obj.top_half': 'Top half ({pos} or better)',
    'se.obj.survival': 'Avoid relegation ({pos} or better)',
    'se.onTrack': 'on track',
    'se.offTrack': 'below target',
    'se.confidence': 'Board confidence',
    'se.ultimatumActive': "ULTIMATUM: win {wins} of your next {matches} matches or lose this season's prize money.",
    'se.prizeForfeited': "You failed the ultimatum — this season's prize money is cancelled.",
    'se.ev.season_start': "New season. We're counting on you: {target}.",
    'se.ev.warning': "These results aren't good enough. We expect a reaction.",
    'se.ev.praise': 'Outstanding work, boss. The board is delighted.',
    'se.ev.ultimatum': 'Our patience has run out. Win {wins} of the next {matches}.',
    'se.ev.ultimatum_passed': 'You answered under pressure. The board backs you again.',
    'se.ev.ultimatum_failed': 'You failed the ultimatum. There will be no prize this season.',
    'se.ev.verdict_met': 'Objective achieved, finishing {pos}. Congratulations!',
    'se.ev.verdict_missed': 'You finished {pos}. That fell short of expectations.',
    'se.promotion': 'Promotion',
    'se.relegation': 'Relegation',
    'se.club': 'Club',
    'se.p': 'P',
    'se.w': 'W',
    'se.d': 'D',
    'se.l': 'L',
    'se.gd': 'GD',
    'se.pts': 'Pts',
    'se.form': 'Form',
    'se.yourFixtures': 'Your fixtures',
    'se.md': 'MD',
    'se.lastResults': 'Last matchday',
    'se.noResults': 'No results yet — play your first matchday!',
    'nav.club': 'Club',
    'nav.play': 'Play',
    'nav.compete': 'Compete',
    'nav.me': 'Profile',
    'nav.overview': 'Overview',
    'nav.feed': 'Community',
    'nav.quickMatch': 'Quick Match',
    'nav.tournaments': 'Tournaments',
    'nav.career': 'Career',
    'nav.missions': 'Missions',
    'nav.trophies': 'Trophies',
    'tour.play': 'Play — the main button. Play your season, a quick match, challenge friends or join tournaments.',
    'tour.club': 'Club — squad, tactics, training and transfers.',
    'tour.compete': 'Compete — league table, rankings and private leagues.',
    'tour.me': 'Profile — career, missions, trophies, shop and settings.',
    'common.save': 'Save',
    'common.saving': 'Saving...',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.refresh': 'Refresh',
    'common.clear': 'Clear',
    'common.loading': 'Loading...',
    'common.retry': 'Retry',
    'common.all': 'All',
    'common.edit': 'Edit',
    'common.unknown': 'Unknown',

    // Header
    'header.teamRank': 'Team Rank',
    'header.coachRank': 'Coach Rank',
    'header.budget': 'Budget',
    'header.points': 'pts',
    'header.level': 'Level',
    'header.online': 'Online',
    'header.offline': 'Offline',
    'header.language': 'Language',

    // Dashboard
    'dash.office': "Manager's Office",
    'dash.playMatch': 'Play match',
    'dash.playFirstMatch': 'Play your first match',
    'dash.challenge': 'Challenge',
    'dash.tactics': 'Tactics',
    'dash.invite': 'Invite',
    'dash.lastMatch': 'Last Match',
    'dash.recap': 'Recap',
    'dash.victory': 'VICTORY',
    'dash.defeat': 'DEFEAT',
    'dash.draw': 'DRAW',
    'dash.noMatch': 'NO MATCH',
    'dash.noRecentMatches': 'No recent matches',
    'dash.startJourney': 'Challenge an opponent and show what you\'ve got!',
    'dash.playNow': 'Play Now',
    'dash.starPerformer': 'Star Performer',
    'dash.noStandout': 'No standout yet',
    'dash.squadStatus': 'Squad Status',
    'dash.squad': 'SQUAD',
    'dash.fit': 'Fit',
    'dash.injured': 'Injured',
    'dash.suspended': 'Suspended',
    'dash.allClear': 'All clear · no unavailable players',
    'dash.offline': 'Offline',
    'dash.challengeHint': 'Launch a challenge',
    'dash.challengeHintOff': 'Set Online in the header to challenge',
    'dash.scouting': 'Scouting opponent...',
    'dash.tacticalSetup': 'Tactical Setup · Live',
    'dash.style': 'STYLE',
    'dash.formation': 'Formation',
    'dash.mentality': 'Mentality',
    'dash.pressing': 'Pressing',
    'dash.line': 'Line',
    'dash.tempo': 'Tempo',

    // Challenges
    'ch.arena': 'Challenges · Arena',
    'ch.title': 'CHALLENGES',
    'ch.league': 'League',
    'ch.points': 'Points',
    'ch.promotion': 'promotion',
    'ch.today': 'Challenges Today',
    'ch.remaining': 'remaining',
    'ch.buyExtra': 'Buy extra challenge',
    'ch.boughtExtra': 'Extra challenge added!',
    'ch.status': 'Status',
    'ch.acceptsChallenges': 'accepts challenges',
    'ch.closed': 'closed',
    'ch.challenge': 'Challenge',
    'ch.quickMatch': 'Quick Match',
    'ch.randomChallenge': 'Random Challenge',
    'ch.searching': 'Searching…',
    'ch.mustBeOnline': 'Set your status to Online before challenging.',
    'ch.dailyLimit': 'Daily challenge limit reached (3/day).',
    'ch.challengeStartError': 'Challenge sent but the match could not be opened. Check Live matches / history.',
    'ch.toggleError': 'Failed to change status. Try again.',
    'ch.onlineNote': 'You must be Online to challenge and be challenged. Tap the Status card to toggle.',
    'ch.tapToToggle': 'Tap to toggle',

    // Available teams
    'at.title': 'AVAILABLE TEAMS',
    'at.subtitle': 'Available Opponents',
    'at.search': 'Search by team or coach...',
    'at.online': 'Online',
    'at.coach': 'Coach',
    'at.noOpponents': 'No opponents available',
    'at.comeBack': 'Come back later to find opponents',
    'at.clearSearch': 'Clear search',

    // Matches / History
    'mh.archive': 'Match Archive · Sector 05',
    'mh.title': 'HISTORY',
    'mh.games': 'Games',
    'mh.total': 'total',
    'mh.wins': 'Wins',
    'mh.draws': 'Draws',
    'mh.losses': 'Losses',
    'mh.wShort': 'W',
    'mh.dShort': 'D',
    'mh.lShort': 'L',
    'mh.winRate': '% win rate',
    'mh.empty': 'No matches in history',
    'mh.emptyHint': 'Your matches will appear here after your first challenge.',
    'mh.seeMore': 'Show more ({count})',
    'mh.seeLess': 'Show less',
    'mh.final': 'Final',
    'mh.scheduled': 'Scheduled',
    'mh.home': 'Home',
    'mh.away': 'Away',

    // Squad
    'sq.section': 'Squad Management · Sector 03',
    'sq.title': 'SQUAD',
    'sq.size': 'Size',
    'sq.avgOvr': 'Avg OVR',
    'sq.value': 'Value',
    'sq.xi': 'XI Selected',
    'sq.startingXi': 'Starting XI',
    'sq.substitutes': 'Substitutes',
    'sq.reserves': 'Reserves',
    'sq.search': 'Search squad...',
    'sq.saveLineup': 'Save Lineup',
    'sq.noStarters': 'No players in Starting XI',
    'sq.noSubs': 'No substitutes selected',
    'sq.noPlayers': 'No players found',
    'sq.scouting': 'Scouting players...',
    'sq.xiInvalid': 'Inconsistent XI',
    'sq.xiTooMany': 'You have {n} players in the XI (limit: 11). Click to fix.',
    'sq.xiTooFew': 'Only {n}/11 players in the XI. Promote reserves to complete.',
    'sq.autofix': 'Auto-fix',
    'sq.pos': 'Pos',
    'sq.player': 'Player',
    'sq.age': 'Age',
    'sq.actions': 'Actions',
    'sq.segXi': 'XI',
    'sq.bench': 'Bench',
    'sq.toXi': '→ XI',
    'sq.toBench': '→ Bench',
    'sq.toRes': '→ Res',
    'sq.moveTo': 'Move to',
    'sq.moveAria': 'Move {name} to: {dest}',
    'sq.actionsFor': 'Actions for {name}',
    'sq.ageShort': '{n}Y',
    'sq.inj': 'Inj',
    'sq.injN': 'Inj {n}',
    'sq.sus': 'Sus',
    'sq.listedChip': 'Listed',
    'sq.attrs': 'Attributes',
    'sq.aAtk': 'ATK',
    'sq.aPas': 'PAS',
    'sq.aSpd': 'SPD',
    'sq.aDef': 'DEF',
    'sq.aSta': 'STA',
    'sq.aGk': 'GK',
    'sq.fAll': 'All',
    'sq.fGK': 'GK',
    'sq.fDEF': 'DEF',
    'sq.fMID': 'MID',
    'sq.fATT': 'ATT',
    'sq.filterPos': 'Filter by position',
    'sq.sort': 'Sort',
    'sq.sortAsc': 'Ascending',
    'sq.sortDesc': 'Descending',
    'sq.clear': 'Clear',
    'sq.noMatch': 'No players match “{q}”',
    'sq.emptyXi': 'Pick 11 players from the bench or reserves.',
    'sq.emptyRes': 'Everyone is in the matchday squad.',
    'sq.showBench': 'Show bench',
    'sq.saving': 'Saving…',
    'sq.saved': 'Saved',
    'sq.saveFailed': 'Save failed',
    'sq.savedOk': 'Change saved.',
    'sq.saveErr': 'Could not save.',
    'sq.loadErr': 'Could not load the squad.',
    'sq.notFound': 'Player not found.',
    'sq.movedSubsN': 'Player moved to the bench. The XI now has {n} players.',
    'sq.movedPromoted': 'Player moved and a reserve promoted.',
    'sq.noReserves': 'No reserves to promote. Promote a reserve before moving this player out of the XI.',
    'sq.gkInXi': 'You already have a goalkeeper in the XI. Move them to the bench first.',
    'sq.xiExact': 'The starting XI must have exactly 11 players.',
    'sq.lineupSaved': 'Lineup saved!',
    'sq.fixedN': '{n} players moved to the bench.',
    'sq.fixErr': 'Could not fix the XI.',
    'sq.listedOk': 'Player listed on the market.',
    'sq.listErr': 'Could not list the player.',
    'sq.askPrice': 'Set an asking price for {name}.',
    'sq.price': 'Price (€)',
    'sq.marketValue': 'market value {v}',
    'sq.priceRange': 'allowed: {min} – {max}',
    'sq.confirmSale': 'Confirm sale',
    'sq.listing': 'Listing…',
    'sq.confirmQuick': 'Confirm · +{v}',

    // Training
    'tr.section': 'Training Center · Sector 04',
    'tr.title': 'TRAINING',
    'tr.attribute': 'Attribute',
    'tr.player': 'Player',
    'tr.cost': 'Cost',
    'tr.balance': 'Balance',
    'tr.coins': 'coins',
    'tr.available': 'available',
    'tr.chooseAttr': 'Attribute to train',
    'tr.costByPos': 'Cost by Position',
    'tr.attrCost': 'Attributes & Training Cost',
    'tr.costHint': 'Each session gives +1 to the attribute. Cost = current value × 1000 coins.',
    'tr.gainInfo': '+1 per session · max 99',
    'tr.selectToSeeCosts': 'Select a player to see attributes and costs.',
    'tr.maxed': 'Maxed',
    'tr.processing': 'Processing...',
    'tr.trainResult': 'Trained! {stat}: {from} → {to}',
    'tr.maxedStat': 'This attribute is already maxed (99).',
    'tr.insufficientCoins': 'Insufficient coins for this session.',
    'tr.selectPlayerFirst': 'Select a player to train.',
    'tr.trainError': 'An error occurred while training the player.',
    'tr.playerSelected': '{name} selected!',
    'tr.selectionRemoved': 'Selection removed.',
    'tr.coinsLoadError': 'Could not load the team coins.',
    'tr.playersLoadError': 'Could not load the squad players.',
    'tr.trainPlayer': 'Train Player',
    'tr.selectPlayer': 'Select Player',
    'tr.selectHint': 'Select a player from your squad to train',
    'tr.clickSelect': 'Click to select',
    'tr.noSquadPlayers': 'No players available in the squad',
    'tr.clickToChoose': 'Click to choose from squad',
    'tr.scheduled': 'Player selected',
    'tr.train': 'Train',
    'tr.cancel': 'Cancel',
    'tr.trainedTitle': 'Training complete',
    'tr.trainedSub': '+1 point in this attribute',
    'tr.overall': 'Rating (overall)',
    'tr.cost': 'Cost',
    'tr.continue': 'Continue',
    'tr.premium': 'Premium Content',
    'tr.advancedMethods': 'ADVANCED METHODS',
    'tr.advancedDesc': 'Unlock specialized training programs and accelerate squad development.',
    'tr.unlock': 'Unlock',
    'tr.includes': 'Tactical, physical and technical training',

    // Transfers
    'tf.hub': 'Transfer Hub',
    'tf.manage': 'Manage your player transfers and squad finances.',
    'tf.budget': 'Transfer Budget',
    'tf.market': 'Transfer Market',
    'tf.shortlist': 'Shortlist',
    'tf.selling': 'For Sale',
    'tf.history': 'History',
    'tf.searchName': 'Search player name...',
    'tf.allPositions': 'All Positions',
    'tf.priceValue': 'Price / Value',
    'tf.noMarket': 'No players on the market matching your criteria.',
    'tf.emptyShortlist': 'Your shortlist is empty.',
    'tf.noSelling': 'No players for sale',
    'tf.noSellingHint': 'List players on the market from the squad or details.',
    'tf.forSale': 'For sale',
    'tf.stop': 'Stop',
    'tf.stopSelling': 'Stop selling',
    'tf.buys': 'Buys',
    'tf.sells': 'Sales',
    'tf.noHistory': 'No {type} in history',
    'tf.noTransfers': 'No transfers yet.',
    'tf.sign': 'Sign',
    'tf.addShortlist': 'Add to Shortlist',
    'tf.removeShortlist': 'Remove from Shortlist',
    'tf.signPlayer': 'Sign Player',
    'tf.overall': 'Overall Rating',
    'tf.attributes': 'Player Attributes',
    'tf.currentClub': 'Current Club',
    'tf.transferFee': 'Transfer Fee',
    'tf.coach': 'Coach',
    'tf.details': 'Details',
    'tf.sell': 'Sell',
    'tf.years': 'yrs',

    // Friends
    'fr.network': 'Friends Network',
    'fr.addFriend': 'Add new friend',
    'fr.friendEmail': "Coach's email or username",
    'fr.send': 'Send Request',
    'fr.received': 'Received requests',
    'fr.sent': 'Sent requests',
    'fr.myFriends': 'My friends',
    'fr.noPending': 'No pending requests.',
    'fr.noSent': 'No sent requests.',
    'fr.noFriends': "You haven't added any friends yet.",
    'fr.count': 'Friends',
    'fr.pendingCount': 'Pending',
    'fr.accept': 'Accept',
    'fr.reject': 'Reject',
    'fr.challenge': 'Challenge',
    'fr.msgChallengeFail': "Couldn't challenge (they may not be in your league).",
    'fr.cancel': 'Cancel',
    'fr.remove': 'Remove',
    'fr.since': 'Since',
    'fr.available': 'Available to challenge',
    'fr.noAvailable': 'No friends available to challenge.',
    'fr.loading': 'Loading data...',
    'fr.privacy': 'Privacy & security',
    'fr.msgInvalidEmail': 'Please enter a valid email or username',
    'fr.msgSent': 'Friend request sent successfully!',
    'fr.msgSendFail': 'Failed to send request',
    'fr.msgNowFriend': "You're now friends with {name}!",
    'fr.msgAcceptFail': 'Failed to accept request',
    'fr.msgRejected': 'Request rejected',
    'fr.msgRejectFail': 'Failed to reject request',
    'fr.msgCancelled': 'Request cancelled',
    'fr.msgCancelFail': 'Failed to cancel request',
    'fr.msgRemoved': '{name} was removed from your friends list',
    'fr.msgRemoveFail': 'Failed to remove friend',

    // League
    'lg.competition': 'Competition · Sector 02',
    'lg.title': 'STANDINGS',
    'lg.subtitle': 'Track your progress and challenge the best coaches',
    'lg.matchWeek': 'Match Week',
    'lg.standings': 'Standings · Live',
    'lg.table': 'TABLE',
    'lg.clickTeam': 'Click a team for details',
    'lg.globalStats': 'Global Stats',
    'lg.h2h': 'Head-to-Head',
    'lg.h2hHint': 'your matches vs this team',
    'lg.last5': 'Last 5 matches',
    'lg.h2hMatches': 'Head-to-head matches',
    'lg.noMatches': 'No matches recorded',
    'lg.backendNote': 'Global stats for other teams require backend support. Showing: head-to-head.',
    'lg.myPos': 'Your position',
    'lg.of': 'of',

    // Notifications
    'nt.eyebrow': 'Club · Alerts',
    'nt.title': 'NOTIFICATIONS',
    'nt.inbox': 'INBOX',
    'nt.unread': 'Unread',
    'nt.all': 'All',
    'nt.filterUnread': 'Unread',
    'nt.markAll': 'Mark all',
    'nt.empty': 'No notifications',
    'nt.delete': 'Delete',

    // Activity Feed
    'feed.eyebrow': 'World · Live',
    'feed.title': 'ACTIVITY',
    'feed.all': 'All',
    'feed.friends': 'Friends',
    'feed.empty': 'No recent activity',
    'feed.movedTo': 'moved to',
    'feed.unlocked': 'unlocked',
    'fr.ranking': 'Friends Ranking',
    'fr.you': 'YOU',

    // Stats Leaderboards
    'lb.title': 'RANKINGS',
    'lb.eyebrow': 'Global Rankings · Stats',
    'lb.subtitle': 'The best in the world — teams, scorers and defenders',
    'lb.tabLeague': 'League',
    'lb.tabTeams': 'Teams',
    'lb.tabGoals': 'Top Scorers',
    'lb.tabAssists': 'Assists',
    'lb.tabDefense': 'Defense',
    'lb.tabRating': 'Rating',
    'lb.team': 'Team',
    'lb.player': 'Player',
    'lb.played': 'P',
    'lb.wins': 'W',
    'lb.draws': 'D',
    'lb.losses': 'L',
    'lb.points': 'Pts',
    'lb.goalsFor': 'GF',
    'lb.goalsAgainst': 'GA',
    'lb.goalDiff': 'GD',
    'lb.cleanSheets': 'CS',
    'lb.goals': 'Goals',
    'lb.assists': 'Assists',
    'lb.perMatch': 'per Match',
    'lb.rating': 'Rating',
    'lb.tackles': 'Tackles',
    'lb.interceptions': 'Intercept.',
    'lb.clearances': 'Clearances',
    'lb.saves': 'Saves',
    'lb.defScore': 'Def. Score',
    'lb.all': 'All',
    'lb.defenders': 'Defenders',
    'lb.goalkeepers': 'Goalkeepers',
    'lb.empty': 'No data yet — play more matches!',
    'lb.loadFail': 'Failed to load data',
    'lb.page': 'Page',
    'lb.prev': 'Previous',
    'lb.next': 'Next',

    // Tactics
    'tc.section': 'Tactics · Sector 06',
    'tc.title': 'TACTICS',
    'tc.visualize': 'Visualize',
    'tc.presets': 'Quick Presets · Play Style',
    'tc.presetsHint': 'Configure all parameters in one click. Then fine-tune and save.',
    'tc.current': 'Current',
    'tc.dirty': 'Unsaved changes.',
    'tc.dirtyHint': "Don't forget to click Save to apply.",
    'tc.saveNow': 'Save now',
    'tc.need11Banner': 'Pick all 11 starters so your team is saved ({n} left).',
    'tc.unsavedTitle': 'Unsaved changes',
    'tc.unsavedBody': "You have unsaved tactics changes. Save before leaving?",
    'tc.unsavedSave': 'Save and leave',
    'tc.unsavedDiscard': 'Leave without saving',
    'tc.unsavedCancel': 'Cancel',
    'tc.mentality': 'Mentality',
    'tc.avgRating': 'Avg Rating',
    'tc.status': 'Status',
    'tc.ready': 'Ready ✓',
    'tc.missing': 'Missing {n}',
    // Cards / labels of the instructions column
    'tc.card.general': 'General Philosophy',
    'tc.card.attack': 'Attacking Organisation',
    'tc.card.defense': 'Defensive Structure',
    'tc.card.setpieces': 'Set Pieces',
    'tc.card.takers': 'Designated Takers',
    'tc.lab.mentality': 'Mentality',
    'tc.lab.afterLoss': 'After Loss',
    'tc.lab.transition': 'Transition',
    'tc.lab.buildup': 'Build-up',
    'tc.lab.style': 'Play Style',
    'tc.lab.focus': 'Play Focus',
    'tc.lab.width': 'Width',
    'tc.lab.tempo': 'Tempo',
    'tc.lab.passing': 'Passing',
    'tc.lab.crossing': 'Crossing',
    'tc.lab.defLine': 'Defensive Line',
    'tc.lab.pressing': 'Pressing',
    'tc.lab.aggression': 'Aggression',
    'tc.lab.intensity': 'Intensity',
    'tc.lab.marking': 'Marking Type',
    'tc.lab.corners': 'Corners',
    'tc.lab.freekicks': 'Free Kicks',
    'tc.lab.defFocus': 'Defensive Focus',
    'tc.sp.offensive': 'Offensive',
    'tc.sp.defensive': 'Defensive',
    'tc.tk.penalty': 'Penalties',
    'tc.tk.corner': 'Corners',
    'tc.tk.shortFK': 'Short Free Kicks',
    'tc.tk.longFK': 'Long Free Kicks',
    'tc.takersWarn': 'Complete the starting XI to set up the takers.',
    'tc.selectPlaceholder': 'Select...',
    // Options (label = display; the value sent to backend stays the same)
    'tc.o.ment.defensiva': 'Defensive — Prioritise solidity',
    'tc.o.ment.cautelosa': 'Cautious — Defensive balance',
    'tc.o.ment.equilibrada': 'Balanced — Perfect balance',
    'tc.o.ment.positiva': 'Positive — Seek the attack',
    'tc.o.ment.ofensiva': 'Attacking — Total pressure',
    'tc.o.loss.recuar': 'Drop back',
    'tc.o.loss.gegenpress': 'Gegenpress',
    'tc.o.trans.lenta': 'Slow',
    'tc.o.trans.rapida': 'Fast',
    'tc.o.build.curta': 'Short — Build from the back',
    'tc.o.build.longa': 'Long — Direct play',
    'tc.o.style.passes': 'Passing Game',
    'tc.o.style.contra-ataque': 'Counter-attack',
    'tc.o.style.organizado': 'Organised Attack',
    'tc.o.style.direto': 'Direct Play',
    'tc.o.style.alas': 'Down the Wings',
    'tc.o.style.tiki-taka': 'Tiki-taka',
    'tc.o.focus.lado-esquerdo': 'Left Side',
    'tc.o.focus.zona-central': 'Through the Middle',
    'tc.o.focus.lado-direito': 'Right Side',
    'tc.o.focus.misto': 'Mixed — Vary',
    'tc.o.width.estreita': 'Narrow',
    'tc.o.width.equilibrada': 'Balanced',
    'tc.o.width.larga': 'Wide',
    'tc.o.tempo.baixo': 'Low',
    'tc.o.tempo.normal': 'Normal',
    'tc.o.tempo.alto': 'High',
    'tc.o.pass.curtos': 'Short',
    'tc.o.pass.misto': 'Mixed',
    'tc.o.pass.diretos': 'Direct',
    'tc.o.cross.baixos': 'Low',
    'tc.o.cross.misto': 'Mixed',
    'tc.o.cross.altos': 'High',
    'tc.o.line.baixa': 'Low',
    'tc.o.line.media': 'Medium',
    'tc.o.line.alta': 'High',
    'tc.o.press.baixo': 'Low',
    'tc.o.press.medio': 'Medium',
    'tc.o.press.alto': 'High',
    'tc.o.aggr.baixa': 'Low',
    'tc.o.aggr.moderada': 'Moderate',
    'tc.o.aggr.agressivo': 'Aggressive',
    'tc.o.int.baixa': 'Low',
    'tc.o.int.normal': 'Normal',
    'tc.o.int.alta': 'High',
    'tc.o.mark.zona': 'Zonal — By zones',
    'tc.o.mark.homem': 'Man-to-man',
    'tc.o.corn.misto': 'Mixed',
    'tc.o.corn.primeiro-poste': 'Near Post',
    'tc.o.corn.segundo-poste': 'Far Post',
    'tc.o.corn.curtos': 'Short',
    'tc.o.fk.direto': 'Direct on Goal',
    'tc.o.fk.cruzamento': 'Cross',
    'tc.o.fk.curto': 'Short',
    'tc.o.dfoc.primeiro-poste': 'Near Post',
    'tc.o.dfoc.segundo-poste': 'Far Post',
    'tc.o.dfoc.centro': 'Centre',
    'tc.o.dfoc.misto': 'Mixed',
    'tc.o.dcorn.misto': 'Mixed',
    'tc.o.dcorn.zonal': 'Zonal',
    'tc.o.dcorn.homem': 'Man-to-man',
    'tc.o.dfk.muralha': 'Wall',
    'tc.o.dfk.linha-alta': 'High Line',
    'tc.o.dfk.zona': 'Zonal Marking',
    // Selection modals (player / taker)
    'tc.select': 'Select',
    'tc.recommendedFirst': 'Recommended players appear first',
    'tc.viewDetails': 'Click to view details',
    'tc.recommended': 'Recommended',
    'tc.idealPos': 'Ideal position',
    'dc.eyebrow': 'Daily bonus',
    'dc.toGo': '{n} more for +{coins} coins',
    'dc.claimed': 'Bonus claimed!',
    'dc.claimedFull': 'Daily bonus claimed — +{coins} coins 🎉',
    'tc.outOfPosWarn': 'Out of position — rating reduced ~{pct}% in the engine.',
    'tc.outOfPosMajorTip': 'Out of position · −{pct}%',
    'tc.outOfPosMinorTip': 'Specific position · −{pct}%',
    'tc.outOfPos': 'Out of position',
    'tc.noPlayers': 'No players available',
    'tc.lineup': 'Line up',
    'tc.playerDetail': 'Player Detail',
    'tc.close': 'Close',
    'tc.cancel': 'Cancel',
    'tc.tdesc.penalty': 'High finishing and composure under pressure',
    'tc.tdesc.corner': 'Excellent crossing and passing ability',
    'tc.tdesc.freekick': 'Good shooting technique and accurate passing',
    'tc.stat.gk': 'Goalkeeping',
    'tc.stat.def': 'Defending',
    'tc.stat.pas': 'Passing',
    'tc.stat.att': 'Attacking',
    'tc.stat.pac': 'Speed',
    'tc.stat.sta': 'Stamina',
    // Pitch hint + notifications
    'tc.pitchHint': 'Click a position to line up a player',
    'tc.notif.gkPosOnly': 'Only a goalkeeper can fill the GK position.',
    'tc.notif.gkPlayerOnly': 'A goalkeeper can only play in the GK position.',
    'tc.notif.moved': 'Player moved to a new position.',
    'tc.notif.cleared': 'Lineup cleared.',
    'tc.notif.injuredCantPlay': 'Injured player can\'t play — stays on the bench until recovered.',
    'tc.notif.injuredMovedOut': '{n} injured player(s) removed from the XI. Line up a replacement.',
    'tc.injuredTag': 'Injured · {n}g',
    'tc.injuredShort': 'Injured',
    'tc.injuredCantPlay': 'Injured — can\'t play',
    'tc.notif.need11': 'Error: select exactly 11 unique starters.',
    'tc.notif.tacticsSavedNeed11': 'Tactics saved. The lineup needs exactly 11 starters to be stored.',
    'tc.notif.tacticsSavedNoGk': 'Tactics saved. The XI needs exactly 1 goalkeeper to store the lineup.',
    'tc.notif.tacticsSavedManyGk': 'Tactics saved. The XI has {n} goalkeepers (max 1) — fix it to store the lineup.',
    'tc.notif.saved': 'Tactics and squad saved successfully!',
    'tc.notif.saveErr': 'Error saving tactics.',
    'tc.notif.saveLineupErr': 'Error saving lineup.',
    // Visualizer
    'tc.viz.onPitch': 'ON THE PITCH',
    'tc.viz.attackUp': 'Attack upwards ↑',
    'tc.viz.effect': 'Parameter effect',
    'tc.lab.attackFocus': 'Attack Focus',
    'tc.viz.fx.mentality': 'Position of the block on the pitch',
    'tc.viz.fx.defLine': 'Height of the last line (volt dashes)',
    'tc.viz.fx.pressing': 'Zone where the ball is won (volt shadow)',
    'tc.viz.fx.width': 'Distance of the channels from the centre',
    'tc.viz.fx.focus': 'Where the attack is focused (target)',
    'tc.viz.fx.tempo': 'Speed of ball circulation',
    // Extra values (width/focus) for visualizer translation
    'tc.v.estreita': 'Narrow',
    'tc.v.equilibrada': 'Balanced',
    'tc.v.larga': 'Wide',
    'tc.v.lado-esquerdo': 'Left',
    'tc.v.zona-central': 'Centre',
    'tc.v.lado-direito': 'Right',
    'tc.v.misto': 'Mixed',
    // Formations (name + description)
    'tc.f.4-4-2.name': '4-4-2 Classic', 'tc.f.4-4-2.desc': 'Classic balance.',
    'tc.f.4-3-3.name': '4-3-3 Attack', 'tc.f.4-3-3.desc': 'Pressure and attacking width.',
    'tc.f.4-2-3-1.name': '4-2-3-1 Control', 'tc.f.4-2-3-1.desc': 'Possession and attacking creativity.',
    'tc.f.3-5-2.name': '3-5-2 Dynamic', 'tc.f.3-5-2.desc': 'Midfield dominance with advanced wingbacks.',
    'tc.f.5-3-2.name': '5-3-2 Block', 'tc.f.5-3-2.desc': 'Low block with full-backs close to defence.',
    'tc.f.5-4-1.name': '5-4-1 Wall', 'tc.f.5-4-1.desc': 'Defensive solidity, fast transitions.',
    'tc.f.4-1-4-1.name': '4-1-4-1 Compact', 'tc.f.4-1-4-1.desc': 'Defensive solidity and transition.',
    'tc.f.4-3-1-2.name': '4-3-1-2 Diamond', 'tc.f.4-3-1-2.desc': 'Concentrated inside play.',
    'tc.f.4-4-1-1.name': '4-4-1-1 Support', 'tc.f.4-4-1-1.desc': 'Security with support behind the striker.',
    'tc.f.3-4-3.name': '3-4-3 Pressure', 'tc.f.3-4-3.desc': 'Width and constant pressure on the wings.',
    'tc.f.4-2-4.name': '4-2-4 Impact', 'tc.f.4-2-4.desc': 'Maximum attacking presence and width.',
    'tc.f.3-4-1-2.name': '3-4-1-2 Creative', 'tc.f.3-4-1-2.desc': 'CAM feeding two strikers, with wide wing-backs.',
    'tc.f.4-5-1.name': '4-5-1 Density', 'tc.f.4-5-1.desc': 'Compactness and attacking patience.',
    'tc.f.4-3-2-1.name': '4-3-2-1 Tree', 'tc.f.4-3-2-1.desc': 'Controlled midfield with two attacking midfielders.',
    'tc.f.4-2-2-2.name': '4-2-2-2 Pairs', 'tc.f.4-2-2-2.desc': 'Two CDMs and two playmakers behind two strikers.',
    'tc.f.5-2-3.name': '5-2-3 Transitions', 'tc.f.5-2-3.desc': 'Solidity at the back with three up front.',
    'tc.f.3-2-4-1.name': '3-2-4-1 Flow', 'tc.f.3-2-4-1.desc': 'Two holding midfielders and four ahead.',
    'tc.f.3-5-1-1.name': '3-5-1-1 Balance', 'tc.f.3-5-1-1.desc': 'Central creativity supporting the striker.',
    'tc.presetApplied': "Style '{name}' applied. Remember to save.",
    // Presets (play styles)
    'tc.preset.park-the-bus.label': 'Park the Bus',
    'tc.preset.park-the-bus.desc': 'Extreme defending — low block, counter-attack',
    'tc.preset.counter-attack.label': 'Counter-Attack',
    'tc.preset.counter-attack.desc': 'Cautious — wait and break at speed',
    'tc.preset.balanced.label': 'Balanced',
    'tc.preset.balanced.desc': 'Default setup — adaptable',
    'tc.preset.tiki-taka.label': 'Tiki-Taka',
    'tc.preset.tiki-taka.desc': 'Possession — short passing, positional pressing',
    'tc.preset.gegenpress.label': 'High Press',
    'tc.preset.gegenpress.desc': 'Klopp style — win the ball high with intensity',
    // Tactical values (mentality / pressing / line / tempo)
    'tc.v.defensiva': 'Defensive',
    'tc.v.cautelosa': 'Cautious',
    'tc.v.equilibrada': 'Balanced',
    'tc.v.positiva': 'Positive',
    'tc.v.ofensiva': 'Attacking',
    'tc.v.baixo': 'Low',
    'tc.v.médio': 'Medium',
    'tc.v.alto': 'High',
    'tc.v.baixa': 'Low',
    'tc.v.média': 'Medium',
    'tc.v.alta': 'High',
    'tc.v.normal': 'Normal',

    // Player Stats
    'ps.career': 'Career',
    'ps.matches': 'Games',
    'ps.goals': 'Goals',
    'ps.assists': 'Assists',
    'ps.rating': 'Rating',
    'ps.age': 'Age',
    'ps.country': 'Country',
    'ps.height': 'Height',
    'ps.weight': 'Weight',
    'ps.minutes': 'Minutes',
    'ps.yellow': 'Yellow',
    'ps.red': 'Red',
    'ps.passAcc': 'Pass Accuracy',
    'ps.shotAcc': 'Shot Accuracy',
    'ps.recentForm': 'Recent Form',
    'ps.noStats': 'Career stats unavailable for this player.',

    // Game Loading
    'game.loadingTitle': 'Booting simulation...',
    'game.stepUser': 'Load user data',
    'game.stepTeam': 'Sync team network',
    'game.stepPlayers': 'Load roster',
    'game.stepFinish': 'Standby ready',
    'game.error': 'Failed to load team',

    // Shop
    'shop.vault': 'Club Investment · Vault',
    'shop.title': 'CLUB SHOP',
    'shop.subtitle': 'Invest in your club’s future.',
    'shop.buy': 'Buy',
    'shop.pack.small': 'Seed Funding',
    'shop.pack.medium': 'Local Sponsor',
    'shop.pack.big': 'Cash Injection',
    'shop.pack.pro': 'Angel Investor',
    'shop.pack.elite': 'Oil Tycoon',
    'shop.pack.mega': 'Billionaire Owner',
    // Shop — gold coins, conversion, items, challenges
    'shop.balance': 'Balance',
    'shop.coins': 'Money',
    'shop.inSquadNote': 'The players are already in your squad (reserves).',
    'shop.goToSquad': 'Go to squad',
    'shop.gold': 'Gold Coins',
    'shop.goldPacks': 'Buy Gold Coins',
    'shop.goldPacksHint': 'Paid with real money (Stripe). Use gold coins for extra challenges and private leagues.',
    'shop.convert': 'Convert Coins → Gold',
    'shop.convertHint': 'Trade club money for gold (€{rate} = 1 gold).',
    'shop.convertAmount': 'Gold to receive',
    'shop.convertCost': 'Cost',
    'shop.convertBtn': 'Convert',
    'shop.extra': 'Extra Challenges',
    'shop.extraHint': 'Each extra slot costs {coins} coins or {gold} gold.',
    'shop.buyWithCoins': 'Pay with coins',
    'shop.buyWithGold': 'Pay with gold',
    'shop.items': 'Items',
    'shop.noItems': 'No items available right now.',
    'shop.buyReal': 'Buy',
    'shop.purchaseOk': 'Purchase complete!',
    'shop.purchaseErr': 'Could not complete the purchase.',
    'shop.insufficient': 'Insufficient balance.',
    'shop.redirecting': 'Redirecting to payment...',
    'shop.playerPacks': 'Player Packs',
    'shop.playerPacksHint': 'Open a pack and get random players within the pack overall range.',
    'shop.buyCoins': 'Buy Money',
    'shop.buyCoinsHint': 'Top up your club budget with real money (Stripe).',
    'shop.packsUnavailable': 'Unavailable right now. (backend: GET /store/packs)',
    'shop.openPack': 'Open Pack',
    'shop.tapToOpen': 'Tap to open',
    'shop.revealNext': 'Next card',
    'shop.packResult': 'New players',
    'shop.continue': 'Continue',
    'shop.opening': 'Opening...',
    'shop.cardOne': 'CARD',
    'shop.cards': 'CARDS',
    'shop.packTier.bronze': 'Bronze Pack',
    'shop.packTier.silver': 'Silver Pack',
    'shop.packTier.gold': 'Gold Pack',
    'shop.packTier.diamond': 'Diamond Pack',
    'shop.packDesc': 'Get {n} player(s) · OVR {min}-{max}',
    'shop.extraName': 'Extra Challenge',
    'shop.extraDesc': '+1 challenge slot',
    // Private Leagues
    'nav.leagues': 'Private Leagues',
    'pl.section': 'Private Leagues · Social Arena',
    'pl.title': 'PRIVATE LEAGUES',
    'pl.subtitle': 'Create or join leagues with your friends.',
    'pl.create': 'Create League',
    'pl.createHint': 'Create a league and share the invite code.',
    'pl.leagueName': 'League name',
    'pl.createBtn': 'Create',
    'pl.join': 'Join with Code',
    'pl.joinHint': 'Got an invite code? Join here.',
    'pl.inviteCode': 'Invite code',
    'pl.joinBtn': 'Join',
    'pl.myLeagues': 'My Leagues',
    'pl.noLeagues': "You're not in any private league yet.",
    'pl.noStandings': 'No matches yet — share the code so friends can join and start playing.',
    'pl.stRecruiting': 'Recruiting',
    'pl.stActive': 'Active',
    'pl.stCompleted': 'Completed',
    'pl.stCancelled': 'Cancelled',
    'pl.prize': 'Prize',
    'pl.recruitEndsIn': 'Recruiting ends in',
    'pl.endsIn': 'Ends in',
    'pl.dailyChallenges': 'Today',
    'pl.challengeBtn': 'Challenge',
    'pl.you': 'YOU',
    'pl.winnerIs': '🏆 Champion: {name}',
    'pl.recruitingHint': 'Waiting for members — you need 3+ within 24h, otherwise the league is cancelled and the gold refunded.',
    'pl.noDailyLeft': 'No league challenges left today. Come back tomorrow.',
    'pl.cantLeaveActive': "You can't leave while the season is running.",
    'pl.duration': 'Duration',
    'pl.durationLabel': 'Season length',
    'pl.daysShort': 'd',
    'pl.maxMembers': 'Max members',
    'pl.createFieldsHint': 'Season length and the maximum number of players who can join.',
    'pl.createPrizeNote': 'At season end, the 1st place wins a prize in gold + coins.',
    'pl.copy': 'Copy code',
    'pl.share': 'Share',
    'pl.shareText': 'Join my league "{name}" on My Football Game! Invite code: {code}',
    'pl.shareCopied': 'Code copied — share it with your friends!',
    'pl.champPrize': 'Champion prize',
    'pl.matchHistory': 'Match history',
    'pl.prizeWinnerOnly': 'Only the 1st place at season end receives it. No one else.',
    // Live Match Viewer
    'lmv.matchCenter': 'Match Center',
    'lmv.ft': 'FT',
    'lmv.htShort': 'HT',
    'lmv.fullTime': 'Full time',
    'lmv.firstHalf': 'First half',
    'lmv.secondHalf': 'Second half',
    'lmv.kickoff': 'Kick-off',
    'lmv.momentum': 'Attack momentum',
    'lmv.assist': 'Assist: {player}',
    'lmv.skip': 'Skip to end',
    'lmv.continue': 'Continue',
    'lmv.potm': 'Player of the match',
    'lmv.bench': 'Substitutes',
    'lmv.noLineups': 'Lineups not available for this match.',
    'lmv.ratingsAtFt': 'Ratings appear at full time.',
    'lmv.aPlayer': 'a player',
    'lmv.tab.feed': 'Commentary',
    'lmv.tab.stats': 'Stats',
    'lmv.tab.lineups': 'Lineups',
    'lmv.type.season': 'League',
    'lmv.type.challenge': 'Quick match',
    'lmv.type.tournament': 'Tournament',
    'lmv.type.league_challenge': 'Private league',
    'lmv.type.link_challenge': 'Link challenge',
    'lmv.st.shots': 'Shots',
    'lmv.st.possession': 'Possession',
    'lmv.st.xg': 'Expected goals (xG)',
    'lmv.st.on_target': 'Shots on target',
    'lmv.st.corners': 'Corners',
    'lmv.st.free_kicks': 'Free kicks',
    'lmv.st.offsides': 'Offsides',
    'lmv.st.saves': 'Saves',
    'lmv.st.yellow': 'Yellow cards',
    'lmv.st.red': 'Red cards',
    'lmv.pos.Goalkeeper': 'GK',
    'lmv.pos.Defender': 'DEF',
    'lmv.pos.Midfielder': 'MID',
    'lmv.pos.Forward': 'FWD',
    'lmv.c.goal.0': 'GOAL! {player} scores for {team}!',
    'lmv.c.goal.1': '{player} makes no mistake and scores for {team}!',
    'lmv.c.goal.2': '{team} score! A clinical finish from {player}.',
    'lmv.c.own_goal.0': 'Own goal by {player}! Misery for {team}.',
    'lmv.c.save.0': 'Great save by {player}! {opp} came close.',
    'lmv.c.save.1': '{player} flies to deny {opp}.',
    'lmv.c.save.2': 'Shot from {opp}, comfortably held by {player}.',
    'lmv.c.miss.0': '{player} shoots... wide!',
    'lmv.c.miss.1': 'A chance for {team}, but {player} fires over.',
    'lmv.c.miss.2': '{player} tries his luck, off target.',
    'lmv.c.block.0': '{opp} shot blocked by {player}.',
    'lmv.c.block.1': '{player} throws himself in the way to stop {opp}.',
    'lmv.c.offside.0': '{player} is flagged offside.',
    'lmv.c.offside.1': 'Flag up: {player} strayed offside.',
    'lmv.c.corner.0': 'Corner to {team}.',
    'lmv.c.corner.1': '{team} win a corner, but it is cleared.',
    'lmv.c.free_kick.0': 'Free kick to {team}, no danger.',
    'lmv.c.free_kick.1': '{team} take the free kick and the defence deals with it.',
    'lmv.c.yellow_card.0': 'Yellow card for {player} ({team}).',
    'lmv.c.yellow_card.1': 'The referee books {player}.',
    'lmv.c.red_card.0': 'Red card! {player} is sent off and {team} are down to ten.',
    'lmv.c.injury.0': '{player} is injured and needs treatment.',
    'lmv.c.injury.1': 'Worry for {team}: {player} is down.',
    'lmv.c.substitution.0': '{team} substitution: {in} on, {out} off.',
    'lmv.c.penalty_scored.0': 'Penalty scored by {player}!',
    'lmv.c.penalty_missed.0': 'Penalty missed by {player}!',
    'lmv.reconnect': 'Reconnect',
    'lmv.halftime': 'Half-time',
    'lmv.startingSoon': 'Kick-off coming up',
    'lmv.underway': 'Match underway — no events yet',
    'lmv.leave': 'Leave Match',
    'lmv.forfeitTitle': 'Abandon Match?',
    'lmv.forfeitBody': 'If you leave now, it will count as a',
    'lmv.forfeitLoss': '3-0 loss',
    'lmv.forfeitConfirm': 'Yes, Forfeit',
    'lmv.forfeitCancel': 'Keep Playing',
    // Broadcast Moments
    'mm.goal': 'GOAAAAL!',
    'mm.ownGoal': 'OWN GOAL',
    'mm.save': 'SAVE!',
    'mm.penalty': 'PENALTY!',
    'mm.offside': 'OFFSIDE',
    'mm.yellow': 'YELLOW CARD',
    'mm.red': 'SENT OFF',
    'mm.sub': 'SUBSTITUTION',
    'mm.miss': 'OFF TARGET!',
    'mm.block': 'BLOCKED!',
    'mm.kickoff': 'KICK-OFF',
    'mm.fulltime': 'FULL TIME',
    'mm.live': 'LIVE',
    'mm.lastPlay': 'Last play',
    'mm.noPlaysYet': 'Ball rolling — no events yet',
    'pl.members': 'members',
    'pl.owner': 'Owner',
    'pl.standings': 'Standings',
    'pl.team': 'Team',
    'pl.played': 'P',
    'pl.win': 'W',
    'pl.draw': 'D',
    'pl.loss': 'L',
    'pl.gd': 'GD',
    'pl.points': 'Pts',
    'pl.copyCode': 'Copy code',
    'pl.copied': 'Copied!',
    'pl.leave': 'Leave league',
    'pl.delete': 'Delete league',
    'pl.kick': 'Kick',
    'pl.back': 'Back',
    'pl.createdOk': 'League created! Code: {code}',
    'pl.joinedOk': 'You joined the league!',
    'pl.leftOk': 'You left the league.',
    'pl.errGeneric': 'Something went wrong. Try again.',
    'pl.costNote': 'Creating a league costs {gold} gold coins.',
    'pl.noGold': "You don't have enough gold to create the league.",

    // Auth & Registration
    'reg.title': 'NEW COACH',
    'reg.subtitle': 'Start your managerial career here.',
    'reg.step1': 'Credentials',
    'reg.step2': 'Club Details',
    'reg.teamName': 'Team Name',
    'reg.username': 'Your Name (Coach)',
    'reg.email': 'Email Space',
    'reg.password': 'Password',
    'reg.confirmPass': 'Confirm Password',
    'reg.agree': 'I accept the ',
    'reg.terms': 'Terms & Conditions',
    'reg.back': 'Back',
    'reg.next': 'Proceed →',
    'reg.create': 'Establish Club',
    'reg.creating': 'Processing...',
    'reg.hasAccount': 'Already have access?',
    'reg.login': 'Login here',

    // Login
    'login.title': 'WELCOME BACK',
    'login.subtitle': 'Access your club management.',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.remember': 'Remember me',
    'login.submit': 'ACCESS SYSTEM',
    'login.loading': 'Verifying credentials...',
    'login.noAccount': 'Don\'t have managerial status yet?',
    'login.register': 'Register here',
    'reg.emailIsRequired': 'Email is required',
    'reg.coachNameIsRequired': 'Coach name is required',
    'reg.teamNameIsRequired': 'Team name is required',
    'reg.invalidEmail': 'Invalid email',
    'reg.passwordMustBeAt': 'Password must be at least 6 characters',
    'reg.registrationFailedPleaseTry': 'Registration failed. Please try again.',
    'reg.play': 'PLAY',
    'reg.now': 'NOW',
    'reg.freeNoDownload30': 'Free · No download · 30 seconds',
    'reg.100CoachesPlaying': '100+ coaches playing',
    'reg.signingIn': 'Signing in...',
    'reg.signUpWithGoogle': 'Sign up with Google',
    'reg.1ClickTeamAuto': '1 click · team auto-generated',
    'reg.orSignUpWith': '— or sign up with email —',
    'reg.email2': 'email',
    'reg.password2': 'Password',
    'reg.min6Characters': 'Min 6 characters',
    'reg.coachName': 'Coach Name',
    'reg.eGAlexFerguson': 'e.g. Alex Ferguson',
    'reg.teamName2': 'Team Name',
    'reg.eGThunderFc': 'e.g. Thunder FC',
    'reg.inviteCodeOptional': 'Invite code (optional)',
    'reg.invalidCode': 'Invalid code',
    'reg.creating2': 'Creating...',
    'reg.createTeam': 'Create Team',
    'reg.bySigningUpYou': 'By signing up, you agree to the ',
    'reg.marketingConsent': 'Email me game news and updates. You can unsubscribe at any time.',
    'login.signingIn': 'Signing in...',
    'login.continueWithGoogle': 'Continue with Google',
    'login.orWithEmail': 'or with email',
    'wel.yourFirstMatchIs': 'Your first match is already being simulated!',
    'wel.yourTeamIsReady': 'Your team is ready and your first match has been launched! Check the result on your dashboard.',
    'wel.goToDashboard': 'Go to Dashboard',
    'com.inviteFriends': 'INVITE FRIENDS',
    'com.earnRewards': 'Earn Rewards',
    'com.youGet50kCoins': 'You get 50K coins + 5 gold',
    'com.whenYourFriendPlays': 'when your friend plays their first match.',
    'com.yourFriendGets25k': 'Your friend gets 25K coins on signup.',
    'com.code': 'CODE',
    'com.shareInvite': 'Share Invite',
    'com.copied': 'Copied!',
    'com.invited': 'Invited',
    'com.active': 'Active',
    'com.earned': 'Earned',
    'com.referralSystemUnavailable': 'Referral system unavailable.',
    'com.community': 'COMMUNITY',
    'com.joinUs': 'Join Us',
    'com.chatChallengesCommunityTips': 'Chat, challenges & community tips',
    'reg.features': '18 tactical formations|Transfer market|Live match simulation|Private leagues',
    'reg.invitedBy': '✓ Invited by {coach} — you\'ll get 25K bonus coins!',
    'com.shareText': 'Join me on My Football Game! Use code {code} for 25K bonus coins ⚽🪙',
    'av.noneFound': 'No teams found',
    'av.tryAnother': 'Try another name',
    'ts.saving': 'Saving...',
    'ts.serverTooBig': 'The logo is too large for the server. Try another image or paste a URL.',
    'tour.knockout': 'Knockout',
    'go.gameOver': 'Game Over',
    'go.finalStats': 'Your Final Stats',
    'go.seasons': 'Seasons Managed',
    'go.finalPosition': 'Final position',
    'go.shareTwitter': 'Share to Twitter',
    'go.shareFacebook': 'Share to Facebook',
    'go.shareReddit': 'Share to Reddit',
    'go.shareWhatsapp': 'Share via WhatsApp',
    'go.copyResult': 'Copy result to clipboard',
    'go.betterLuck': 'Better luck with your next club! Ready for another challenge?',
    'go.feedbackTitle': 'Your Feedback Matters!',
    'go.fbGeneral': 'General Feedback',
    'go.fbGameplay': 'Gameplay',
    'go.fbDifficulty': 'Difficulty',
    'go.fbBugs': 'Bugs/Issues',
    'go.fbSuggestions': 'Suggestions',
    'go.fbOther': 'Other',
    'go.fbPlaceholder': 'What did you like or dislike? Any suggestions?',
    'go.thanks': 'Thank You!',
    'go.thanksBody': 'Your feedback has been submitted. We appreciate it!',
    'rev.financial': 'Financial Impact',
    'rev.reputation': 'Reputation Change',
    'rev.percentage': 'Percentage Change',
    'rev.impact': 'Event Impact',
    'rev.attention': 'This event requires your attention. How would you like to proceed?',
    'av.eyebrow': 'Available Opponents',
    'av.title': 'AVAILABLE TEAMS',
    'av.search': 'Search by team or coach...',
    'av.coach': 'Coach',
    'av.challenging': 'Challenging...',
    'av.challenge': 'Challenge',
    'av.loadError': 'Couldn\'t load available teams',
    'av.dailyLimit': 'Daily challenge limit reached! You can send 3 challenges a day.',
    'av.noneAvailable': 'No opponents available',
    'av.comeBack': 'Come back later to find opponents',
    'set.inviteFriends': 'Invite Friends',
    'set.inviteBody': 'Share your code: earn 50K coins + 5 gold when your friend plays their first match. They get 25K bonus coins on signup!',
    'set.yourCode': 'Your Invite Code',
    'set.playing': 'Playing',
    'set.recentInvites': 'Recent Invites',
    'mr.timeline': 'Match Timeline',
    'mr.comparison': 'Team Comparison',
    'mr.points': 'Points Earned',
    'mr.fans': 'Fan Happiness',
    'mr.revenue': 'Match Revenue',
    'mr.scorers': 'Your Scorers',
    'cmr.injured': 'Player injured!',
    'cmr.leaguePoints': 'League points',
    'cmr.coins': 'Coins',
    'ts.title': 'Club Settings',
    'ts.teamName': 'Team name',
    'ts.clubName': 'Club name',
    'ts.pasteUrl': '…or paste an image URL',
    'ts.save': 'Save',
    'ts.loadError': 'Couldn\'t load your team.',
    'ts.pickImage': 'Choose an image file.',
    'ts.tooBig': 'Image too large (max 10MB).',
    'ts.readError': 'Couldn\'t read the image.',
    'ts.invalidImage': 'Invalid image.',
    'ts.processError': 'Couldn\'t process the image.',
    'ts.saveError': 'Couldn\'t save.',
    'mh.eyebrow': 'Manager',
    'mh.morale': 'Morale',
    'mh.keepPlaying': 'Keep playing to level up!',
    'mh.objectivesSoon': 'Season objectives will appear soon',
    'mh.overview': 'Overview',
    'mh.training': 'Training',
    'mh.objectives': 'Objectives',
    'tour.eyebrow': 'Competitive',
    'tour.teams': 'Teams',
    'tour.entryFee': 'Entry Fee',
    'tour.prizePool': 'Prize Pool',
    'tour.format': 'Format',
    'tour.prizeDistribution': 'Prize Distribution',
    'tour.bracket': 'Bracket',
    'mis.none': 'No missions available yet',
    'mis.weekly': 'Weekly',
    'mis.allDone': 'All missions completed!',
    'sq.sellPlayer': 'Sell Player',
    'tac.player': 'Player',
    'tac.attributes': 'Attributes',
    'tac.preview': 'Tactical Preview',
    'tac.startersSet': 'Starters selected',
  },
  es,
};

const I18nContext = createContext({ lang: DEFAULT_LANG, setLang: () => {}, t: (k) => k });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === 'undefined') return DEFAULT_LANG;
    const saved = localStorage.getItem(STORAGE_KEY);
    if (LANGS.includes(saved)) return saved;
    // No choice yet: follow the browser when we speak its language, English otherwise
    // (defaulting everyone to Portuguese put English-speaking players into a game they couldn't read).
    const browser = (navigator.languages?.[0] || navigator.language || '').toLowerCase().slice(0, 2);
    return LANGS.includes(browser) ? browser : 'en';
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch (_) { /* ignore */ }
  }, []);

  const t = useCallback((key, vars) => {
    const table = dict[lang] || dict[DEFAULT_LANG];
    // Missing keys fall back to English, the language most players can read.
    let str = table[key] ?? dict.en[key] ?? key;
    if (vars) {
      Object.keys(vars).forEach((k) => {
        str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), vars[k]);
      });
    }
    return str;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);

export default I18nContext;
